/// <reference path="../_references.js" />

var gDashboardPage = null;

// STATE MANAGER HANDLERS
function mStateManagerDashboard_Init(aPrevious, aCurrent) {
    "use strict";
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        gLoadScreenCounter++;
        var lLayout = aCurrent.Tab + '.Layout.htm';
        populateElement('uMasterContentHolder', lLayout, uMasterContentHolder_OnLoad);
    } else {
        systemCacheItems_Init();
    }
}

function mStateManagerDashboard_Leave(aPrevious, aCurrent) {
    "use strict";
    if (!isNullOrUndefined(gDashboardPage)) {
        gDashboardPage.dispose();
        gDashboardPage = null;
    }
}

function DashboardPage() {
    "use strict";

    DashboardPage.prototype.baseClass.call(this);
    var mThis = this,
        mControls = new DashboardControls(),
        mData = new DashboardData();
    mData.IsDataIntitialized = !this.isNothing(getCacheItem('EventTile'));

    this.lv = function () {
        return mControls.ListView;
    };

    function listView_OnUpdate() {
        if (!isNullOrUndefined(mControls.ListViewFilter)) {
            var lListViewTop = $("#uEnrolleeEventSummaryListViewViewPort").scrollTop();
            var lListHeight = $('#uEnrolleeEventSummaryListViewViewPort');
            var lSelected = $(".sumo-data-row-selected");
            if (lListHeight.length > 0) {
                lListHeight = lListHeight[0].scrollHeight;
            }
            mControls.ListViewFilter.filter();
            mControls.ListView.setUpdated(false);
            var lListHeightAfter = $('#uEnrolleeEventSummaryListViewViewPort');

            if (lListHeightAfter.length > 0 && lSelected.length > 0) {
                var lListMargin = Math.abs(lListHeight - lListHeightAfter[0].scrollHeight);
                if (lListMargin > 0) {
                    lListViewTop = ((lListViewTop + lSelected.offset().top) + lSelected[0].scrollHeight + 17);
                } else {
                    lListViewTop = (lListViewTop + lSelected.offset().top);
                }

            }
            $("#uEnrolleeEventSummaryListViewViewPort").scrollTop(lListViewTop);
            setScroll();
        }
    }

    function listView_OnUpdateNotice() {
        mControls.ListView.setUpdateNotice(false);
    }

    function dataItem_OnUpdate(aParams, aCache) {
        var lPreferences = getUserPreferences(13),
            lUpdateValue = 0;
        if (!isNullOrUndefined(mControls.ListView)) {
            var lUpdatedReturn = UpdateViewOnNewDataReturn(aCache, mData.DataPaginated, true);

            if (lUpdatedReturn.IsFound) {
                if (!isNullOrUndefined(lPreferences['AutomaticDashboardUpdate'])) {
                    lUpdateValue = parseInt(lPreferences['AutomaticDashboardUpdate'].Value);
                }

                if (lUpdateValue) {
                    listView_OnUpdate();
                    mControls.ListView.setUpdateNotice(true, localizeText('cDashboardLastUpdate') + DisplayShortMomentTime(moment()));
                    mActivityNotification.addNotification(localizeWrapper('cDefaultRefreshing'));
                } else {
                    mControls.ListView.setUpdated(true);
                }
            }
        }
    }

    function checkValidDashboardEvents(aReports){
        "use strict";
       var lPreferences = getUserPreferences(13),
            lUpdateValue = 0,
            lResult = 0,
            lEnrolleeIds = [],
            lEvents = [],
            lGroupIds = [];

        if (!isNullOrUndefined(lPreferences['AutomaticDashboardUpdate'])) {
            lUpdateValue = parseInt(lPreferences['AutomaticDashboardUpdate'].Value);
        }

        if (lUpdateValue) {
            for(var lKey in aReports){
                if(aReports.hasOwnProperty(lKey)){
                    if (aReports[lKey].GroupId.length > 0){
                        lEnrolleeIds.push(aReports[lKey].EnrolleeId);
                    for(var a in aReports[lKey].GroupId){
                        if(aReports[lKey].GroupId.hasOwnProperty(a)){
                            if(lGroupIds.indexOf(aReports[lKey].GroupId[a]) == -1){
                                lGroupIds.push(aReports[lKey].GroupId[a]);
                            }
                        }
                    }
                }
              }
            }

            if (lEnrolleeIds.length > 0) {
                var lPredicateBuilder = new SumoPredicateBuilder();
                var lMetaEventList = getGroupMetaEvents(lGroupIds);
                var lIds = getMetaEventIds(lMetaEventList);

                lPredicateBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('IsConfirmed', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('MetaEventId', lIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lPredicateBuilder.AddNewExpressionConditional('MetaEventId', [16, 17, 65, 129], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
                lEvents = query(getDataItems('Events'), lPredicateBuilder.RootExpression);

                lPredicateBuilder.Clear();

                var lMetaEventIds = getMetaEventIds(lEvents);

                for (var lKey in aReports) {
                    if (aReports.hasOwnProperty(lKey)) {
                        var lReportGroup = getGroupMetaEvents(aReports[lKey].GroupId);
                        var lGroupIds = getMetaEventIds(lReportGroup);
                        for (var a in lGroupIds) {
                            if (lGroupIds.hasOwnProperty(a)) {
                                if (lMetaEventIds.indexOf(lGroupIds[a]) !== -1) {
                                    lResult++;
                                }
                            }
                        }
                    }
                }
            }
        }
        return lResult;
    }

    function processAnnoyingLights(lReports){
      "use strict";
        var lPreferences = getUserPreferences(13),
          lAutoDasboardEnabled = veritracks.system.clientSetting('autodashboardrefreshenabled'),
          lCount = 0,
          lUpdateValue = 0;

      if (!isNullOrUndefined(lPreferences['AutomaticDashboardUpdate'])) {
          lUpdateValue = parseInt(lPreferences['AutomaticDashboardUpdate'].Value);
      }

      if (lUpdateValue && lAutoDasboardEnabled) {
        for(var lKey in lReports){
          if(lReports.hasOwnProperty(lKey)){
            if(lReports[lKey].IsAssigned){
              lCount += lReports[lKey].EventCount;
            }
          }
        }
        if(lCount == 0){
          lCount += checkValidDashboardEvents(lReports);
        }
        checkForUnconfirmedEventsDashboard(lCount);
      }

      return true;
    }

    function checkForUnconfirmedEventsDashboard(aCount) {
        var lPreferences = getUserPreferences(13),
            lOnLights = "AnnoyingLights",
            lOffLights = "AnnoyingLightsBeGone",
            lUpdateValue = 0;
        var lBrowser = get_browser() + get_browser_version();

        if ($.inArray(lBrowser, ["MSIE9", "MSIE8"]) != -1) {
            lOnLights = "AnnoyingLightsIE";
            lOffLights = "AnnoyingLightsBeGoneIE";
        }

        if (!isNullOrUndefined(lPreferences['AutomaticDashboardUpdate'])) {
            lUpdateValue = parseInt(lPreferences['AutomaticDashboardUpdate'].Value);
        }

        if (lUpdateValue && aCount > 0) {
            $('#uDashboardContentRow').removeClass(lOffLights);
            $('#uDashboardContentRow').addClass(lOnLights);
        } else {
            if ($('#uDashboardContentRow').hasClass(lOnLights)) {
                $('#uDashboardContentRow').removeClass(lOnLights);
                $('#uDashboardContentRow').addClass(lOffLights);
            } else {
                $('#uDashboardContentRow').removeClass(lOnLights);
            }
        }
    }



    this.dashboardSummaryReportIconAlcohol = function(aEnrolleeId) {
        "use strict";
        var lOrganization,
          lBuilder = new SumoPredicateBuilder(),
          lSort = new SortExpression(),
          lOffenderAlcoholSchedules = [],
          lOffenderAlcoholeImages = Object.assign([], gAlcoholLastTest),
          lAlcoholAssignments = getDataItems('AlcoholDeviceAssignments'),
          lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
          lEnrolleAlcoholSchedule = null,
          lEnrolleeAlcoholImage = null,
          lDeviceAssignments = null,
          lSelectedAlcoholSchedule = null,
          lSelectedAlcoholImage = null,
          lSelectedDeviceAssingment = null,
          lResult = [],
          lReportIcon = 0,
          lScheduleId = -1,
          lImageId = -1,
          lMaxReTest = -1,
          lTryCount = 0,
          lClass = -1;

        if (!isNullOrUndefined(lEnrollee)) {
            lMaxReTest = checkOrganizationProperty(lEnrollee.OrganizationId, "alcohol_number_of_retests");
            lMaxReTest++;
        }
        
        lBuilder.AddNewExpressionConditional('EndDate', (new Date(9000, 11, 30)), false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceAssignments = query(lAlcoholAssignments, lBuilder.RootExpression);

        for (var key in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(key)) {
                lSelectedDeviceAssingment = lDeviceAssignments[key];
                break;
            }
        }

       
        
        if (!isNullOrUndefined(lSelectedDeviceAssingment)) {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('StatusId', -1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('ScheduleType', [201, 301, 401], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            //lEnrolleAlcoholSchedule = query(lOffenderAlcoholSchedules, lBuilder.RootExpression);
            lEnrolleAlcoholSchedule = query(lOffenderAlcoholeImages, lBuilder.RootExpression);
            
            lSort.addDescendingColumn('StopDate');
            lEnrolleAlcoholSchedule = lSort.sort(lEnrolleAlcoholSchedule);

            for (var key in lEnrolleAlcoholSchedule) {
                if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
                    lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                    break;
                }
            }//end of for

            if (!isNullOrUndefined(lSelectedAlcoholSchedule)) {
                if (!isNullOrUndefined(lOffenderAlcoholSchedules[lSelectedAlcoholSchedule.Id])) {
                    lMaxReTest = lOffenderAlcoholSchedules[lSelectedAlcoholSchedule.Id].MaxNumberRetest;
                }
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('ImageId', lSelectedAlcoholSchedule.ImageId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lEnrolleeAlcoholImage = query(lOffenderAlcoholeImages, lBuilder.RootExpression);
                lEnrolleeAlcoholImage = lSort.sort(lEnrolleeAlcoholImage);
               
                for (var key in lEnrolleeAlcoholImage) {
                    if (lEnrolleeAlcoholImage.hasOwnProperty(key)) {
                        lSelectedAlcoholImage = lEnrolleeAlcoholImage[key];
                        break;
                    }
                }//end of for
            }

            if (!isNullOrUndefined(lSelectedAlcoholSchedule)) {
                lResult.push('<div class="GridIcon');
                if (lSelectedAlcoholSchedule.StatusId != 0 && lMaxReTest > lSelectedAlcoholSchedule.TotalCheck) {
                    lClass = 30;
                } else if ([1, 4, 5].indexOf(lSelectedAlcoholSchedule.StatusId) !== -1) {                    
                    lClass = 1;
                } else if ([2, 3].indexOf(lSelectedAlcoholSchedule.StatusId) !== -1) {
                    lClass = 20;
                } else {                    
                    lClass = 10;
                }
               
                lScheduleId = lSelectedAlcoholSchedule.ScheduleId
                if (!isNullOrUndefined(lSelectedAlcoholImage)) {
                    if (lSelectedAlcoholImage.ImageMatchedFlag == 1) {
                        lClass++;
                    } else if (lSelectedAlcoholImage.ImageMatchedFlag == 0) {
                        lClass = lClass + 3;
                    }
                    lImageId = lSelectedAlcoholImage.Id
                }//end of if
                
                lResult.push(' AlcoholScheduleState');
                lResult.push(lClass.toWholeString(4));
                lResult.push('" onclick="gDashboardPage.showOffenderAlcoholConfirmDialog(' + lScheduleId + ',' + lSelectedAlcoholSchedule.EnrolleeId + ',true);" title="' + localizeText('cEventViewEvents') + '"></div>');
                lResult.push('</div>');
                lResult.push('<span class="GridIconText"></span>');
            }//end of if
        }//end of if

        return lResult.join('');
    }

    function dashboardSummaryReportIcon(aReportItem, aColumnId, aEnrolleeId) {
        "use strict";
        var lOrganization,
            lResult = [],
            lReportIcon = 0,
            lClass = 0;


        lResult.push('<div class="GridIcon');
        if (!isNullOrUndefined(aReportItem)) {
            lOrganization = getDataItem(aReportItem.OrganizationId, 'Organizations');
            if (!isNullOrUndefined(lOrganization)) {
                lClass += (lOrganization.EventActionType * 10);
                if (aReportItem.Value !== '') {
                    lReportIcon = aReportItem.Value;
                    if (mData.EventReportIconsStatus) {
                        if (lReportIcon == "1" || lReportIcon == "3")
                            lReportIcon = "2";
                    }
                    lClass += (parseInt(lReportIcon) * 1000);
                }
                lResult.push(' EventState');
                lResult.push(lClass.toWholeString(4));
            }
        }
        // title="' + 'Confirm ' + getDataItem(aColumnId, 'EventGroup').Description + '"
        if (aColumnId && CheckUserHasPermission(1))
            lResult.push('" onclick="gDashboardPage.showConfirmMetaEventsConfirmDialog(' + aEnrolleeId + ',' + aColumnId + ');" title="'+ localizeText('cEventViewEvents') +'"></div>');
        else
            lResult.push('"></div>');

        lResult.push('<span class="GridIconText"></span>');
        return lResult.join('');
    }

    function dashboardSummaryReportDate(aId, aValue) {
        "use strict";
        var lResult = fixDate(aValue),
            lString = '';
        if (lResult > new Date(10000000000)) {
            lString = DisplayDashboardTimeZone(aId, lResult);
        }
        return lString;
    }

    function DisplayDashboardTimeZone(aId, aResult) {
        "use strict";
        var lTimeZone = getEnrolleeTimeZone(aId);
        return displayEnrolleeTimeZone(aResult, lTimeZone);
    }

    function notesCountPopUpFormatter(aValue, aEnrolleeId) {
        "use strict";
        var lValue = '';
        if (aValue > 0) {
            lValue = '<div class="NotesIconProperty" onclick="gDashboardPage.dashboardNotes_OnClick(\'' + aEnrolleeId + '\')">' + aValue + '</div>';
        }
        return lValue;
    }

    function dashboardEnrolleeProfileNotes_OnLoad(aParams, aData) {
        var lKey,
            lNote;
        FixDates(aData);

        DisplayPopup(localizeWrapper('cEventNotes'), '', null, false);

        mControls.NotesManager = new SumoNotesManager('uPopupContent2', 'uPopupContent', aData, {
            'ClassName': 'Enrollee',
            'IdentificationProperty': 'EnrolleeId',
            'Identifier': aParams,
            'UserId': gUserDetails.UserId,
            'PermissionId': 32
        });
        mControls.NotesManager.RenderContents();
        $('#uPopupContent .ButtonBar').remove();
        $('#uPopupContentListViewPaginationCell').remove();

    }

    this.dashboardNotes_OnClick = function (aEnrolleeId) {
        "use strict";

        var lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression();
        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSort.addDescendingColumn('CreatedDateUTC');

        ReadMultiple(gObjectList.EnrolleeNote.AssemblyQualifiedName, lBuilder.RootExpression, 0, dashboardEnrolleeProfileNotes_OnLoad, Sad, aEnrolleeId, lSort, 0);
    };


    //    function dashboardSummaryReportText(aValue) {
    //        return '<span class="NoWrap">' + aValue + '</span>';
    //    }

    this.iconColumn_OnClick = function (aEnrolleeId) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lDeviceAssignment = gCurrentDeviceAssignment[aEnrolleeId],
            lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
            lPageTitle = 'Offenders',
            lDevice,
            lKey;
        if (lEnrollee.EnrolleeType == 2) {
            lPageTitle = 'Victims'
        }
        mEnrolleesData.OffenderCurrentIdFromDashboard = aEnrolleeId;
        if (!isNullOrUndefined(lDeviceAssignment)) {
            for (lKey in lDeviceAssignment) {
                if (lDeviceAssignment.hasOwnProperty(lKey)) {
                    lDevice = lDeviceAssignment[lKey];
                }
            }
            lDevice = getDataItem(lDevice.Id, 'Devices');
            if (lDevice.ProductId == 103 || lDevice.ProductId == 110 || lDevice.ProductId == 151) {
                window.location.hash = "Enrollees." + lPageTitle + ".Map.Events." + aEnrolleeId;
            }
            else {
                window.location.hash = "Enrollees." + lPageTitle + ".Profile.Events." + aEnrolleeId;
            }
        }
        else {
            window.location.hash = "Enrollees." + lPageTitle + ".Profile.Events." + aEnrolleeId;
        }
    };

    function formatIconColumn(aEnrolleeId) {
        "use strict";
        var lHtml = [];

        lHtml.push('<div title="" class="GridIcon DashboardEnrolleeIcon StopClickBubble');

        if (!gIsSystemCacheLoaded) {
            lHtml.push(' CacheLoadRequired');
        }
        lHtml.push('" onclick="gDashboardPage.iconColumn_OnClick(');
        lHtml.push(aEnrolleeId);
        lHtml.push(')"></div>');
        return lHtml.join('');
    }
    // last location
    this.LocationIconColumn_OnClick = function (aEnrolleeId) {
        "use strict";
        mCache.unbind('DeviceLastContactupdated', DeviceLastContact_Updated);
        mCache.bind('DeviceLastContactupdated', DeviceLastContact_Updated);
        mControls.ListView.selected(aEnrolleeId);
        mData.LastTrackEnrolleeId = aEnrolleeId;
        enrolleeLastLocationGenerator(aEnrolleeId);
    }

    this.showConfirmMetaEventsConfirmDialog = function (aEnrolleeId, aGroupId) {
        "use strict";
        mControls.ListView.selected(aEnrolleeId);
        mData.LastTrackEnrolleeId = aEnrolleeId;
        showConfirmEventsDialog(aGroupId);
    }

    this.showOffenderAlcoholConfirmDialog = function (aItemId, aEnrolleeId) {
        var lBuilder = new SumoPredicateBuilder(),
            lOffenderAlcoholSchedules = [],
            lEnrolleAlcoholSchedule = null,
            lSelectedAlcoholSchedule = null;

        if (aItemId == -1) {
            return;
        }
        GetOffenderAlcoholSchedules(aEnrolleeId, aItemId, function (aParams, aData) {
            lOffenderAlcoholSchedules = aData;
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('ScheduleId', aItemId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lEnrolleAlcoholSchedule = query(lOffenderAlcoholSchedules, lBuilder.RootExpression);
            for (var key in lEnrolleAlcoholSchedule) {
                if (lEnrolleAlcoholSchedule.hasOwnProperty(key)) {
                    lSelectedAlcoholSchedule = lEnrolleAlcoholSchedule[key];
                    break;
                }
            }
    
            if (!isNullOrUndefined(lSelectedAlcoholSchedule)) {
                var lFixDateData = [lSelectedAlcoholSchedule];
                FixDates(lFixDateData);
                uQuickReviewAlcoholMonitoring(lFixDateData[0], mStateManager.Hash());
            }
    
            }, function (a,b) {
                mActivityNotification.addNotification('No Data Found');
            });
        
    }
   

    function formatIconLocationColumn(aEnrolleeId) {
        "use strict";
        var lHtml = [];

        lHtml.push('<div title="" class="GridIcon DashboardLocationIcon StopClickBubble');
        if (!gIsSystemCacheLoaded) {
            lHtml.push(' CacheLoadRequired');
        }
        lHtml.push('" onclick="gDashboardPage.LocationIconColumn_OnClick(');
        lHtml.push(aEnrolleeId);
        lHtml.push(')"></div>');

        return lHtml.join('');
    }

    function enrolleeLastLocationPopup(aId, aLastContact) {
        "use strict";
        var lButtonCommandBar = GenerateButtonCommandBar(),
            lBodyHtml = [],
            lBuilder = new SumoPredicateBuilder(),
            lMapHeight = 0,
            lEnrollee = getDataItem(aId, 'Enrollees'),
            lAgent = getDataItem(lEnrollee.AgentId, 'Agents'),
            lOrganization = getDataItem(lAgent.OrganizationId, 'Organizations'),
            lLastContact = aLastContact,
            lDeviceAssignment = gCurrentDeviceAssignment[aId],
            lDevicesRead = [],
            lDevices = [],
            lTimeZone = getEnrolleeTimeZone(lEnrollee.Id),
            lKey,
            lLastLocationO = {},
            lLastLocation = [],
            lDeviceButtonBar = false,
            lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
            lIsTBand = false;
            const DEVICE_LIST=[103,110,151,141,161];

        for (lKey in lDeviceAssignment) {
            if (lDeviceAssignment.hasOwnProperty(lKey)) {
                lDevicesRead.push(lDeviceAssignment[lKey].Id);
            }
        }
        lBuilder.AddNewExpressionConditional('Id', lDevicesRead, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

        var lSoberDeviceButton = false;
        lDevices = query(getDataItems('Devices'), lBuilder.RootExpression);
        for (lKey in lDevices) {
            if (lDevices.hasOwnProperty(lKey)) {
                if (DEVICE_LIST.includes(lDevices[lKey].ProductId)) {
                    lDeviceButtonBar = true;
                    if(lDevices[lKey].ProductId == 161)
                        lIsTBand = true;
                }
                if (lDevices[lKey].ProductId == 121) {
                    lSoberDeviceButton = true;
                }
            }
        }
        if (!isNullOrUndefined(lLastContact) && lLastContact.Latitude != 0 && lLastContact.Longitude != 0) {
            lBodyHtml.push('<table>');
            lBodyHtml.push('<td style="min-width:250px;');
            lBodyHtml.push('"valign="top">');

            lBodyHtml.push('<div id="uLastLocationCommandBar" class="ButtonBar">');
            if (lDeviceButtonBar || lSoberDeviceButton) {
                // enable second popup
                document.getElementById("uPopupPanel2").disabled = false;
                lBodyHtml.push('<div class="DeviceActionButton" style="width:300px;">');
                lBodyHtml.push('<div class="IconButton VibrateDeviceButton pInventoryDeviceAction" title="vibrate device" onclick="gDashboardPage.identifyDeviceActionType(7)"></div>');
                lBodyHtml.push('<div class="IconButton SendAudibleToneButton pInventoryDeviceAction" title="send audible tone" onclick="gDashboardPage.identifyDeviceActionType(6)"></div>');
                lBodyHtml.push('<div class="IconButton LocateDeviceButton pInventoryDeviceAction" title="request location" onclick="gDashboardPage.identifyDeviceActionType(8)"></div>');

                if (lSoberDeviceButton) {
                    if (gDashboardPage.onDemandStatus) {
                        lBodyHtml.push('<div class="IconButton SoberTrackDeviceButton Disabled pInventoryDeviceAction" title="ondemand create" onclick="gDashboardPage.identifyEnrolleeOnDemandAction()"></div>');
                    } else {
                        lBodyHtml.push('<div class="IconButton SoberTrackDeviceButton pInventoryDeviceAction" title="ondemand create" onclick="gDashboardPage.identifyEnrolleeOnDemandAction()"></div>');
                    }
                }else{
                  lBodyHtml.push('<div class="IconButton RapidReportButton pInventoryDeviceAction" id="uEnrolleesRapidReportWrite" title="request rapid reporting" onclick="gDashboardPage.identifyDeviceActionType(9)"></div>');
                }
                lBodyHtml.push('<div class="DarkSpacer FloatLeft MapFilter"></div></div>')
            }


            lBodyHtml.push('</div>');
            lBodyHtml.push('<div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty PropertyTitle">')
            lBodyHtml.push('<p>' + lEnrollee.FirstName + ' ' + lEnrollee.LastName + '</p>');
            lBodyHtml.push('</div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty">');
            lBodyHtml.push(lEnrollee.PrimaryId + '</div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty">');
            lBodyHtml.push('<strong>'+ localizeWrapper('cAgent')+': </strong>' + lAgent.FullName + '</div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty">');
            lBodyHtml.push('<strong>' + localizeWrapper('cEnrolleeOrganization') + ': </strong>' + lOrganization.Name + '</div>');
            // Device Assignments
            for (lKey in lDevices) {
                if (lDevices.hasOwnProperty(lKey)) {
                    var lDevice = lDevices[lKey];
                    lBodyHtml.push('<div class="Property EnrolleeProperty InventoryIconProperty">');
                    lBodyHtml.push(lDevice.SerialNumber);
                    lBodyHtml.push('</div>');
                }
            }
            lBodyHtml.push('<div class="Property EnrolleeProperty CallIconProperty" id="uLastLocationLastContact">');
            lBodyHtml.push(displayEnrolleeTimeZone(lLastContact.ContactDate, lTimeZone) + '</div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty TrackpointIconProperty" id="uLastLocationLastTrack">');
            lBodyHtml.push(displayEnrolleeTimeZone(lLastContact.TrackDate, lTimeZone) + '</div>');
            lBodyHtml.push('<div class="Property EnrolleeProperty" id="uLastLocationLastBatteryLevel" style="display: block;">');
            lBodyHtml.push('<div class="FloatLeft"><div title="battery level' + lLastContact.BatteryLevel + '" class="GridIcon InventoryBattery');
            lBodyHtml.push(lLastContact.BatteryLevel + '"></div></div>');
            lBodyHtml.push('<div id="uLastLocationLastBatteryVoltage" class="FloatLeft" style="padding-left: 10px">');
            lBodyHtml.push(lLastContact.BatteryVoltage + 'v</div></div>');
            lBodyHtml.push('<hr>');
            lBodyHtml.push('<div class="lLastLocationExtended">');
            lBodyHtml.push('<span class="StreetIconProperty" id="uLastLocationStreetView" onclick="gDashboardPage.setStreetLevel(' + aId + ')"></span>');
            lBodyHtml.push('<table style="display:block;"><td valign="top">'+localizeWrapper('cEnrolleeAddress')+': </td><td  title="" id="uLastLocationTrackPointAddress"></td></table>');
            lBodyHtml.push('<div class="Ellipsis MapProperty NoIconProperty Property" id="uLastLocationLatitude" title="' + lLastContact.Latitude + '">' + localizeWrapper('cEnrolleeLatitude') + ': ');
            lBodyHtml.push(lLastContact.Latitude + '</div>');
            lBodyHtml.push('<div class="Ellipsis MapProperty NoIconProperty Property" id="uLastLocationLongitude" title="' + lLastContact.Longitude + '">' + localizeWrapper('cEnrolleeLongitude') + ': ');
            lBodyHtml.push(lLastContact.Longitude + '</div>');
            lBodyHtml.push('<div class="Ellipsis MapProperty NoIconProperty Property" id="uLastLocationSpeed" title="' + lLastContact.Speed + '">' + localizeWrapper('cEnrolleeSpeed') + ': ');
            if (lDoMetric) {
                lBodyHtml.push(convertMilesToKilometers(lLastContact.Speed) + ' kph</div>');
            }
            else {
                lBodyHtml.push(lLastContact.Speed + ' mph</div>');
            }
            lBodyHtml.push('</div>');
            lBodyHtml.push('</div>');
            lBodyHtml.push('</td>');
            lBodyHtml.push('<td rowspan="13" valign="top" style=""id="uEnrolleesLastLocationMapCell"><div id="uEnrolleesLastLocationMapPanel" style="width: 450px; height: 450px; background-color: silver;"></</div></td>');

            lBodyHtml.push('</table>');
        }
        else {
            lBodyHtml.push('<div class="NoData" style="float: left;"> '+ localizeWrapper('cNoData') +' </div>');
        }

        GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'gDashboardPage.LastTrackClosePopup()').appendTo(lButtonCommandBar);
        DisplayPopup(localizeWrapper('cDashboardLastTrack'), lBodyHtml.join(''), lButtonCommandBar, false);
        //HERE apply if is selected 
        if(lIsTBand){
            disableDeviceAction(); 
        }else {
            enableDeviceAction();
        }
        applyUserPermissions([20]);
        if (!isNullOrUndefined(lLastContact)) {
            lMapHeight = $('#uEnrolleesLastLocationMapCell').innerHeight();
            setWidth('#uEnrolleesLastLocationMapPanel', lMapHeight);
            setHeight('#uEnrolleesLastLocationMapPanel', lMapHeight);
            // prepare last location object
            var anchor = { 'x': 11, 'y': 11 };
            lLastLocationO = {
                'anchor': anchor,
                'iconUri': "Images/Maps/Trackpoints/11111000.png",
                'doHover': true,
                'data': lEnrollee,
                'latitude': lLastContact.Latitude,
                'longitude': lLastContact.Longitude
            };
            lLastLocation.push(lLastLocationO);
            uEnrolleeLastLocationtMap_Init(lLastLocation);
        }
    }

    this.LastTrackClosePopup = function () {
        "use strict";
        mData.EnrolleeSelected = null;
        mData.LastTrackEnrolleeId = null;
        ClosePopup();
    }

    function getEnrolleeLastContactByDevice(aId) {
        "use strict";
        var lLastContact = getDataItem(aId, 'EnrolleeLastContact'),
            lDeviceAssignment = gCurrentDeviceAssignment[aId],
            lBuilder = new SumoPredicateBuilder(),
            lSort,
            lDeviceContacts,
            lDeviceId,
            lTemp,
            lDevice = [],
            lKey;

        if (!isNullOrUndefined(lDeviceAssignment)) {
            for (lKey in lDeviceAssignment) {
                if (lDeviceAssignment.hasOwnProperty(lKey)) {
                    lBuilder.AddNewExpressionConditional('DeviceId', lDeviceAssignment[lKey].Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('ContactDate', lDeviceAssignment[lKey].StartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('ContactDate', lDeviceAssignment[lKey].EndDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
                    var lContact = query(getDataItems('DeviceLastContact'), lBuilder.RootExpression);
                    if (ObjectLength(lContact) > 0) {
                        lDeviceContacts = lContact;
                        lDeviceId = lKey;
                    }
                }
            }

            if (!isNullOrUndefined(lDeviceContacts)) {
                if (lDeviceContacts[lDeviceId].Latitude != 0) {
                    lLastContact = lDeviceContacts[lDeviceId];
                }
            }
        }

        return lLastContact;
    }
    function enrolleeLastLocationGenerator(aId) {
        "use strict";
        var lLastContact = getEnrolleeLastContactByDevice(aId),
            lBuilder = new SumoPredicateBuilder(),
            lSort;

        // disable second popup
        document.getElementById("uPopupPanel2").disabled = true;
        if (!isNullOrUndefined(lLastContact)) {
            mData.EnrolleeSelected = lLastContact;
            enrolleeLastLocationPopup(aId, lLastContact);
        }
        else {
            lSort = new SortExpression();
            lSort.addDescendingColumn('ContactDate');
            lBuilder.AddNewExpressionConditional('EnrolleeId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.EnrolleeContactHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, EnrolleeContactHistoryRead_OnComplete, null, null, lSort, 0);
        }

        function EnrolleeContactHistoryRead_OnComplete(aParams, aData) {
            var lContact;
            if (ObjectLength(aData) > 0) {
                FixDates(aData);
                lContact = aData[0];
                mData.EnrolleeSelected = lContact;
            }
            enrolleeLastLocationPopup(aId, lContact);
        }

    }

    this.setStreetLevel = function (aId) {
        var lLastContact = getEnrolleeLastContactByDevice(aId);//, 'EnrolleeLastContact');
        mControls.LastLocationMap.setStreetLevel(lLastContact.Latitude, lLastContact.Longitude);
    }

    this.RefreshLastLocationMap = function (aId) {
        var lLastContact = getEnrolleeLastContactByDevice(aId),
            lEnrollee = getDataItem(aId, 'Enrollees'),
            lLastLocationO = {},
            lTimeZone = getEnrolleeTimeZone(lEnrollee.Id),
            lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
            lLastLocation = [];
        //$('#uLastLocationRefresh').removeClass('RefreshYesButton').addClass('RefreshNoButton');
        mData.EnrolleeSelected = lLastContact;
        function UpdateLastLocation(aAddress) {
            // prepare last location object
            var anchor = { 'x': 11, 'y': 11 },
                lAddress = aAddress.length?aAddress[0]:aAddress;
            lLastLocationO = {
                'anchor': anchor,
                'iconUri': "Images/Maps/Trackpoints/11111000.png",
                'doHover': true,
                'data': lEnrollee,
                'latitude': lLastContact.Latitude,
                'longitude': lLastContact.Longitude
            };
            lLastLocation.push(lLastLocationO);


            mControls.LastLocationMap.layerSetDataSource('Visits', lLastLocation);
            mControls.LastLocationMap.setCenter(lLastLocation[0].latitude, lLastLocation[0].longitude);
            mControls.LastLocationMap.zoom(14);
            $('#uLastLocationLastContact').text(displayEnrolleeTimeZone(lLastContact.ContactDate, lTimeZone));
            $('#uLastLocationLastTrack').text(displayEnrolleeTimeZone(lLastContact.TrackDate, lTimeZone));
            $('#uLastLocationTrackPointAddress').text(lAddress.formated_address);
            $('#uLastLocationTrackPointAddress').attr('title', lAddress.formated_address);
            $('#uLastLocationLatitude').text('Latitude: ' + lLastContact.Latitude);
            $('#uLastLocationLatitude').attr('title', lLastContact.Latitude);
            $('#uLastLocationLongitude').text('Longitude: ' + lLastContact.Longitude);
            $('#uLastLocationLongitude').attr('title', lLastContact.Latitude);

            if (lDoMetric) {
                $('#uLastLocationSpeed').text(lLastContact.Speed + ' kph');
                $('#uLastLocationSpeed').attr('title', lLastContact.Speed);
            } else {
                $('#uLastLocationSpeed').text(lLastContact.Speed + ' mph');
                $('#uLastLocationSpeed').attr('title', lLastContact.Speed);
            }
          
        }

        function init() {
            // geocode on success
            mControls.LastLocationMap.geocode(lLastContact.Latitude.toString() + ', ' + lLastContact.Longitude.toString(), UpdateLastLocation, null);
        }

        init();
    }

    function DeviceLastContact_Updated(aCache, aData) {
        "use strict";
        if (!isNullOrUndefined(mData.EnrolleeSelected) && !isNullOrUndefined(mData.LastTrackEnrolleeId) && PopupIsOpen()) {
            var lDeviceContactOld = mData.EnrolleeSelected,
                lDeviceContactNew = gDeviceLastContact[lDeviceContactOld.DeviceId],
                lCurrentDeviceAssignment = gCurrentDeviceAssignment[mData.LastTrackEnrolleeId];

            lCurrentDeviceAssignment = lCurrentDeviceAssignment[lDeviceContactOld.DeviceId];
            if (!isNullOrUndefined(lCurrentDeviceAssignment)) {
                if (lDeviceContactNew.ContactDate >= lCurrentDeviceAssignment.StartDate) {
                    if (lDeviceContactNew.Latitude != lDeviceContactOld.Latitude || lDeviceContactNew.Longitude != lDeviceContactOld.Longitude || lDeviceContactNew.ContactDate > lDeviceContactOld.ContactDate || lDeviceContactNew.TrackDate > lDeviceContactOld.TrackDate) {
                        gDashboardPage.RefreshLastLocationMap(mData.LastTrackEnrolleeId);
                        mActivityNotification.addNotification(localizeWrapper('cEnrolleeLastTrackRefreshing'));
                        //$('#uLastLocationRefresh').removeClass('RefreshNoButton').addClass('RefreshYesButton');
                    }
                }
            }
        }
    }

    //function EnrolleeLastContact_Updated(aCache, aData) {
    //    "use strict";
    //    var lPredicate = new SumoPredicateBuilder(),
    //        lContacts = null,
    //        lContact = null;

    //    //if (!isNullOrUndefined(mEnrolleesControls.CardView)) {
    //    //    lCardData = mEnrolleesControls.CardView.selectedDataItem();
    //    //}
    //    if (!isNullOrUndefined(mData.EnrolleeSelected)) {
    //        lPredicate.AddNewExpressionConditional('EnrolleeId', mData.EnrolleeSelected.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //        lContacts = query(aData.Data, lPredicate.RootExpression);
    //        var ltest = getDataItem(mData.EnrolleeSelected.EnrolleeId, 'EnrolleeLastContact');
    //        lContact = lContacts[mData.EnrolleeSelected.EnrolleeId];
    //        if (lContact.Latitude != mData.EnrolleeSelected.Latitude || lContact.Longitude != mData.EnrolleeSelected.Longitude || lContact.ContactDate > mData.EnrolleeSelected.ContactDate ||
    //            lContact.TrackDate > mData.EnrolleeSelected.TrackDate){
    //            $('#uLastLocationRefresh').removeClass('RefreshNoButton').addClass('RefreshYesButton');
    //        }
    //    }
    //}

    function uEnrolleeLastLocationtMap_Init(aLastLocation) {
        "use strict";
        var lSystemPreferences = getUserPreferences(10),
            lDisplayType = 'roadmap',
            lLastLocation = aLastLocation;

        if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
            lDisplayType = lSystemPreferences['MapDisplayType'].Value;
        }
        if (!isNullOrUndefined(mControls.LastLocationMap)) {
            mControls.LastLocationMap.dispose();
            mControls.LastLocationMap = null;
        }
        mControls.LastLocationMap = new sumo.maps.GoogleMapControl('uEnrolleesLastLocationMap', 'uEnrolleesLastLocationMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': null });
        var lLayerOptions = {
            'renderType': 'marker',
            'doesPlayback': false,
            'isVisible': true,
            'dragEndEventHandler': null,
            'clickEventHandler': null,
            'zIndexStart': 90000
        };
        mControls.LastLocationMap.layerAdd('Visits', lLayerOptions);
        mControls.LastLocationMap.layerSetDataSource('Visits', lLastLocation);
        mControls.LastLocationMap.setCenter(lLastLocation[0].latitude, lLastLocation[0].longitude);
        mControls.LastLocationMap.zoom(14);
        mControls.LastLocationMap.geocode(lLastLocation[0].latitude.toString() + ', ' + lLastLocation[0].longitude.toString(), onGeocodeComplete, null);

        function onGeocodeComplete(aResult) {
            var lResult = aResult;
            $('#uLastLocationTrackPointAddress').text(lResult.formated_address);
            $('#uLastLocationTrackPointAddress').attr('title', lResult.formated_address);
        }
    }

    function uEnrolleesLastLocationMap_OnDragEnd() {
        "use strict";
    }
    this.zonesColumn_OnClick = function () {
        "use strict";

        window.location.hash = "Zones.Map";
    };

    function prepareColumnData(aReportColumn, aReportId) {
        var lColumn,
            lReportId = aReportId;

        lColumn = { 'id': aReportColumn.Id, 'title': ReportColumnFormatter(aReportColumn.Abbreviation), 'hoverText': ReportColumnFormatter(aReportColumn.Description), 'dataField': aReportColumn.Id, 'sortable': false };
        if (aReportColumn.DisplayType === 1 || aReportColumn.DisplayType === 2) {
            lColumn.width = 48;
            lColumn.minWidth = 24;
            lColumn.cssClass = 'CenterImage';
        } else {
            lColumn.minWidth = 60;
        }

        // custom dashboard sort
        if (!isNullOrUndefined(lReportId) && lReportId > 100) {
            if (aReportColumn.DisplayType !== 1) {
                lColumn.minWidth = 48;
                lColumn.width = 'autoData';
                lColumn.sortable = true;
            }
        }

        return lColumn;
    }

    function getDashboardReportColumn(aReportId) {
        "use strict";
        var lSortPredicate = new SortExpression(),
            lBuilder = new SumoPredicateBuilder(),
            lEnrolleeColumns = getDataItems('EnrolleeReportColumn'),
            lReportColumns = getDataItems('DashboardReportColumn'),
            lEnrolleeColumn,
            lColumns = [],
            lPermission,
            lItem,
            lKey,
            lReportId = null;

        if (aReportId > 100) {
            lReportId = aReportId;
        }

        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DashboardReportId', aReportId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lReportColumns = query(lReportColumns, lBuilder.RootExpression);
        if (!isNullOrUndefined(lReportColumns)) {
            lSortPredicate.addAscendingColumn('SortOrder');
            lReportColumns = lSortPredicate.sort(lReportColumns);
            lPermission = gUserPermissions[13];
            if (!isNullOrUndefined(lPermission) && lPermission.Value !== 0) {
                lColumns.push({ 'id': 'Icon', 'title': '', 'dataField': 'EnrolleeId', 'minWidth': 22, 'width': 'autoData', 'cssClass': 'CenterImage', 'formatMethod': formatIconColumn });
            }
            lColumns.push({
                'id': 'LocationIcon', 'title': localizeWrapper('cDashboardLastTrack'), 'dataField': 'EnrolleeId', 'minWidth': 60, 'width': 'autoData', 'cssClass': 'CenterImage',
                'formatMethod': formatIconLocationColumn
            });
            lColumns.push({ 'id': 'FullName', 'title': localizeWrapper('cEnrollee'), 'dataField': 'FullName', 'width': 'autoData', 'cssClass': 'NoWrap' });
            lColumns.push({ 'id': 'AgentName', 'title': localizeWrapper('cAgent'), 'dataField': 'AgentName', 'width': 'autoData', 'cssClass': 'NoWrap' });
            lColumns.push({ 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'cssClass': 'NoWrap', 'formatMethod': OrganizationNameFormatter });
            for (lKey in lReportColumns) {
                if (lReportColumns.hasOwnProperty(lKey)) {
                    lItem = lReportColumns[lKey];
                    lEnrolleeColumn = lEnrolleeColumns[lItem.EnrolleeReportColumnId];
                    if (!isNullOrUndefined(lEnrolleeColumn)) {
                        lColumns.push(prepareColumnData(lEnrolleeColumn, lReportId));
                    }
                }
            }
        }

        return lColumns;
    }

    function getReportColumnIds(aReportId) {
        "use strict";
        var lSortPredicate = new SortExpression(),
            lPredicateBuilder = new SumoPredicateBuilder(),
            lAllReportColumns = getDataItems('EnrolleeReportColumn'),
            lColumnIds = [],
            lKey = null,
            lColumnData = null,
            lReportColumns = getDataItems('DashboardReportColumn'),
            lReportColumnIds = [];

        lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('DashboardReportId', aReportId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lReportColumns = query(lReportColumns, lPredicateBuilder.RootExpression);
        for (lKey in lReportColumns) {
            if (lReportColumns.hasOwnProperty(lKey)) {
                lReportColumnIds.push(lReportColumns[lKey].EnrolleeReportColumnId);
            }
        }

        lPredicateBuilder.Clear();

        if (lReportColumnIds.length > 0) {
            lPredicateBuilder.AddNewExpressionConditional('Id', lReportColumnIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lColumnData = query(lAllReportColumns, lPredicateBuilder.RootExpression);
            lSortPredicate.addAscendingColumn('SortOrder');
            lColumnData = lSortPredicate.sort(lColumnData);

            for (lKey in lColumnData) {
                if (lColumnData.hasOwnProperty(lKey)) {
                    lColumnIds.push(lColumnData[lKey].Id);
                }
            }
        }
        return lColumnIds;
    }


    function uEnrolleeEventSummaryCustomReportSelect_OnChange(aEvent) {
        "use strict";
        var lSelect = $('#uEnrolleeEventSummaryCustomReportSelect'),
            lValue = lSelect.val(),
            lPreference = new UserPreference(),
            lReport,
            lListViewTop,
            lListHeight,
            lListHeightAfter,
            lListMargin,
            lSelected;

        lListViewTop = $("#uEnrolleeEventSummaryListViewViewPort").scrollTop();
        lListHeight = $('#uEnrolleeEventSummaryListViewViewPort');
        lSelected = $(".sumo-data-row-selected");
        if (lListHeight.length > 0) {
            lListHeight = lListHeight[0].scrollHeight;
        }
        mControls.ListView.setColumns(getDashboardReportColumn(lSelect.val()));
        lListHeightAfter = $('#uEnrolleeEventSummaryListViewViewPort');

        if (lListHeightAfter.length > 0 && lSelected.length > 0) {
            lListMargin = Math.abs(lListHeight - lListHeightAfter[0].scrollHeight);
            if (lListMargin > 0) {
                lListViewTop = ((lListViewTop + lSelected.offset().top) + lSelected[0].scrollHeight + 17);
            } else {
                lListViewTop = (lListViewTop + lSelected.offset().top);
            }

        }
        $("#uEnrolleeEventSummaryListViewViewPort").scrollTop(lListViewTop);
        setScroll();
        lReport = getDataItem(lValue, 'DashboardReport');
        if (isNullOrUndefined(lReport)) {
            $('#uEnrolleeEventSummaryCustomReportSelect').val('1').change();
            //if (!isNullOrUndefined(lValue)) {
            //    createDashboardReportSelect();
            //}
            //lReport = getDataItem(1, 'DashboardReport');
            //$('#uDashboardEditColumnFavorites').hide();
        } else {
            if (lReport.Id < 100) {
                $('#uDashboardEditColumnFavorites').hide();
            } else {
                $('#uDashboardEditColumnFavorites').show();
            }
            lPreference.Id = gUserDetails.UserId;
            lPreference.UserPreferenceType = 5;
            lPreference.ColumnName = 'EnrolleeEventSummaryCustomReportSelect';
            lPreference.Value = lValue;
            writeUserPreferences([lPreference]);
        }


    }

    function createDashboardReportSelect() {
        "use strict";
        var lReports = getDataItems('DashboardReport'),
            lKey = null,
            lReport = null,
            lHtml = [],
            lSelect = $('#uEnrolleeEventSummaryCustomReportSelect'),
            lPreferences = getUserPreferences(5);
        for (lKey in lReports) {
            if (lReports.hasOwnProperty(lKey)) {
                lReport = lReports[lKey];
                if (!isNullOrUndefined(lReport)) {
                    lHtml.push('<option ');
                    if (lReport.Id == 1) {
                        lHtml.push('selected="true"');
                    }
                    lHtml.push('value="');
                    lHtml.push(lReport.Id);
                    lHtml.push('">');
                    lHtml.push(localizeDataItem('',lReport.Description));
                    lHtml.push('</option>');
                }
            }
        }
        lSelect.html(lHtml.join(''));
        lSelect.unbind('change', uEnrolleeEventSummaryCustomReportSelect_OnChange);
        if (!isNullOrUndefined(lPreferences['EnrolleeEventSummaryCustomReportSelect'])) {
            lSelect.val(lPreferences['EnrolleeEventSummaryCustomReportSelect'].Value);
        }

        lSelect.change(uEnrolleeEventSummaryCustomReportSelect_OnChange);
        lSelect.change();
    }

    function hideNotification(aSender, aCacheItem, aNotificationId) {
        "use strict";
        mCache.unbind(aCacheItem.Name + 'updated', hideNotification);
        mActivityNotification.removeNotification(aNotificationId);
    }

    function createTiles() {
        "use strict";

        mControls.Tiles['uEnrolleesTile'] = new sumo.controls.LiveTileControl(
        'uEnrolleesTile',
        'uEnrolleesTileHolder',
        {
            'Title': localizeWrapper('cEnrollees'),
            'dataSourceName': 'EnrolleeTile',
            'IconUri': 'Images/EnrolleesLight40.png',
            'Destination': '#Enrollees.Offenders.Profile.Events',
            'NavigationType': 'hash',
            'RenderDirection': 'horizontal',
            'Cache': mCache,
            'StateManager': mStateManager,
            'ProcRequestMethod': GetEnrolleeTiles
        }
        );

        mControls.Tiles['uAnalysisTile'] = new sumo.controls.LiveTileControl(
        'uAnalysisTile',
        'uAnalysisTileHolder',
        {
            'Title': localizeWrapper('cAnalysis'),
            'dataSourceName': 'AnalysisTile',
            'IconUri': 'Images/AnalysisLight40.png',
            'Destination': '#Analysis.Incidents.Details',
            'NavigationType': 'hash',
            'RenderDirection': 'horizontal',
            'Cache': mCache,
            'StateManager': mStateManager,
            'ProcRequestMethod': GetAnalysisTiles
        }
        );

        if (gUserDetails.Role != 2) {
            mControls.Tiles['uEventsTile'] = new sumo.controls.LiveTileControl(
            'uEventsTile',
            'uEventsTileHolder',
            {
                'Title': localizeWrapper('cEvents'),
                'dataSourceName': 'EventTile',
                'IconUri': 'Images/EventsLight40.png',
                'Destination': '#Events.Map',
                'NavigationType': 'hash',
                'RenderDirection': 'horizontal',
                'Cache': mCache,
                'StateManager': mStateManager,
                'ProcRequestMethod': GetEventTiles
            }
            );

            mControls.Tiles['uZonesTile'] = new sumo.controls.LiveTileControl(
            'uZonesTile',
            'uZonesTileHolder',
            {
                'Title': localizeWrapper('cZones'),
                'dataSourceName': 'ZoneTile',
                'IconUri': 'Images/ZonesLight40.png',
                'Destination': '#Zones.Map',
                'NavigationType': 'hash',
                'RenderDirection': 'horizontal',
                'Cache': mCache,
                'StateManager': mStateManager,
                'ProcRequestMethod': GetZoneTiles
            }
            );

            mControls.Tiles['uReportTile'] = new sumo.controls.LiveTileControl(
            'uReportTile',
            'uReportTileHolder',
            {
                'Title': localizeWrapper('cReports'),
                'dataSourceName': 'ReportTile',
                'IconUri': 'Images/ReportsLight40.png',
                'Destination': '#Reports.Reports.Details',
                'NavigationType': 'hash',
                'RenderDirection': 'horizontal',
                'Cache': mCache,
                'StateManager': mStateManager,
                'ProcRequestMethod': GetReportTiles
            }
            );

            mControls.Tiles['uInventoryTile'] = new sumo.controls.LiveTileControl(
            'uInventoryTile',
            'uInventoryTileHolder',
            {
                'Title': localizeWrapper('cInventory'),
                'dataSourceName': 'InventoryTile',
                'IconUri': 'Images/InventoryLight40.png',
                'Destination': '#Inventory.Devices.Device',
                'NavigationType': 'hash',
                'RenderDirection': 'horizontal',
                'Cache': mCache,
                'StateManager': mStateManager,
                'ProcRequestMethod': GetInventoryTiles
            }
            );

            mControls.Tiles['uAgentsTile'] = new sumo.controls.LiveTileControl(
            'uAgentsTile',
            'uAgentsTileHolder',
            {
                'Title': localizeWrapper('cAgents'),
                'dataSourceName': 'Users',
                'IconUri': 'Images/AgentsLight40.png',
                'Destination': '#Agents.Agents.Profile',
                'NavigationType': 'hash',
                'RenderDirection': 'horizontal',
                'CountMethod': agentTileCounter,
                'Cache': mCache,
                'StateManager': mStateManager,
            }
            );

            //mControls.Tiles['uUsersTile'] = new sumo.controls.LiveTileControl(
            //'uUsersTile',
            //'uUsersTileHolder',
            //{
            //    'Title': localizeWrapper('cUsers'),
            //    'dataSourceName': 'UserTile',
            //    'IconUri': 'Images/UsersLight40.png',
            //    'Destination': '#Users.Profile.Permissions',
            //    'NavigationType': 'hash',
            //    'RenderDirection': 'horizontal',
            //    'Cache': mCache,
            //    'StateManager': mStateManager
            //}
            //);
        }

        if (!gIsSystemCacheLoaded) {
            $('.CacheLoadRequired').hide();
            $('#uDashboardDefaultLoadingContainer').show();
        }
    }

    function agentTileCounter() {
        "use strict";
        var lTile = new Tile();

        lTile.Name = "AgentTile";
        lTile.UserId = gUserDetails.UserId;
        lTile.Value = count(UserHelper.getByIds(gAgentUserIds));

        return [lTile];
    }

    function getIdArray(aCacheItem, aFieldName) {
        "use strict";
        var lKey = null,
            lResult = [],
            lHasId = false;

        if (count(aCacheItem.Data) > 0) {
            for (lKey in aCacheItem.Data) {
                if (aCacheItem.Data.hasOwnProperty(lKey)) {
                    lHasId = !isNullOrUndefined(aCacheItem.Data[lKey][aFieldName]);
                    break;
                }
            }
            if (lHasId === true) {
                for (lKey in aCacheItem.Data) {
                    if (aCacheItem.Data.hasOwnProperty(lKey)) {
                        lResult.push(aCacheItem.Data[lKey][aFieldName]);
                    }
                }
            }
        }
        return lResult;
    }

    this.getEnrolleeEventSummaryListViewPanel = function () {
        "use strict";
        return mData.ListViewPanel;
    };

    this.onDemandStatus = false;

    this.soberTrackStatusOnDemand = function (aStatus) {
        gDashboardPage.onDemandStatus = aStatus;
    };

    function mEnrolleeEventSummaryListView_OnSelectedChanged(aSender, aKeyValue, aThis) {
        "use strict";

        $('#uDebugOutput').html('listview id: ' + aSender.Id + ' fired selectedchanged with data: ' + aKeyValue);

        var lItem = mControls.ListView.selectedDataItem();//,
        //lBuilder = new SumoPredicateBuilder(),
        //lDevices = getDataItems('Devices');

        //lBuilder.AddNewExpressionConditional('SerialNumber', lItem[2021], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //lDevices = query(lDevices, lBuilder.RootExpression);


        if (isNullOrUndefined(lItem) || isNullOrUndefined(lItem[2021]) || !lItem[2021]) {
            $('.DeviceActionButton').hide();
            $('.DeviceActionButtonSpacer').hide();
        } else {
            $('.DeviceActionButton').show();
            $('.DeviceActionButtonSpacer').show();
            showRapidReportingStatusToggle(lItem[2021]);
        }

        if (!isNullOrUndefined(lItem) && lItem[2023]) {
            if (lItem[2023].length) {
                $('.SoberTrackDeviceButton').show();
                $('.DeviceActionButton').show();
                $('.RapidReportButton').hide();
                $('.DeviceActionButtonSpacer').show();

                getSoberTrackOnDemandIsReady(lItem.EnrolleeId, null, gDashboardPage.soberTrackStatusOnDemand);
            } else {
                $('.SoberTrackDeviceButton').hide();
            }

        } else {
            $('.SoberTrackDeviceButton').hide();
        }
        
        if (!isNullOrUndefined(lItem)) {
            setViewState('DashboardSelectedEnrollee', lItem.EnrolleeId);

            mEnrolleesData.OffenderCurrentId = lItem.EnrolleeId
            if (displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId)) {
              $('#uViewScheduleButton').show()
              $('#uEnhancedScheduleButton').hide()

            }else {
              $('#uViewScheduleButton').hide()
              $('#uEnhancedScheduleButton').show()

            }
            $('#uEnhancedScheduleButton')[AgentHelper.getPermissionValueById(16) > 0?'show':'hide']();
            $('.DashboardEnrolleeDataItem').show();
            setScroll();
            const lProductId = getProductIdFromEnrolleeId(lItem.EnrolleeId);
            console.log('lProductId',lProductId);
        //     const lDevice = getDataItem(lEnrollee.TrackingDeviceId, 'Devices');
            const lIsTBand = lProductId === 161;
            if(lIsTBand){
                disableDeviceAction(); 
            }else {
                enableDeviceAction();
            }
        } else {
            $('.DashboardEnrolleeDataItem').hide();
        }
        
    }



    function uDashboardListView_OnColumnsChanged(aSender, aParams, aData) {
        mControls.ListView.bind('databind', dashboardListView_OnDataBind);
    }

    function uDashboardListView_OnColumnsChanging(aSender, aParams, aData) {
        mControls.ListView.unbind('databind', dashboardListView_OnDataBind);
    }

    function dashboardListView_OnDataBind(aSender, aParams, aData) {
        "use strict";
        if (isNullOrUndefined(aSender.selected())) {
            cardView_OnDataBind(aSender, aParams, aData);
        }
    }

    function uDashboardListView_OnDataBind(aSender, aParams, aData) {
        "use strict";
        mControls.ListView.unbind('databind', uDashboardListView_OnDataBind);

        mControls.ListView.bind('databind', dashboardListView_OnDataBind);
        mControls.ListView.bind('columnschanging', uDashboardListView_OnColumnsChanging);
        mControls.ListView.bind('columnschanged', uDashboardListView_OnColumnsChanged);
        mControls.ListView.selected(aData);

    }





    function createEnrolleeEventSummaryListView() {
        "use strict";
        var lSelect = $('#uEnrolleeEventSummaryCustomReportSelect'),
            lViewState = getViewState('DashboardSelectedEnrollee'),
            lColumns = [],
            lKey,
            lOptions = {
                enableCellNavigation: true,
                enableColumnReorder: true
            };

        lColumns.push({ 'id': 'Selected', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': 'SelectionColumn', 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': true });
        lColumns.push({ 'id': 'Name', 'title': localizeWrapper('cDashboardColumn'), 'dataField': 'Description', 'width': 'autoData', 'cssClass': 'NoWrap', 'dataType': 'string', 'formatMethod': ReportColumnFormatter});
        lColumns.push({ 'id': 'Abbreviation', 'title': localizeWrapper('cDashboardAbbr'), 'dataField': 'Abbreviation', 'width': 'autoData', 'cssClass': 'NoWrap', 'dataType': 'string', 'formatMethod': ReportColumnFormatter });
        mControls.ColumnsListView = new sumo.controls.ListView('uColumnListView', 'uColumnListViewHolder',
        {
            'keyField': 'Id',
            'keyFieldType': 'number',
            'cssClass': 'VeritracksSelectListView',
            'scrollIntoView': false,
            'selectMethod': 'auto'
        },
        lColumns);
        mControls.ColumnsListView.setDataSource(getDataItems('EnrolleeReportColumn'));


        lColumns = null;
        if (lSelect.length > 0 && lSelect[0].innerHTML !== '') {
            lColumns = getDashboardReportColumn(lSelect.val());
        } else {
            lColumns = getDashboardReportColumn(1);
        }
        mControls.ListView = new sumo.controls.ListView('uEnrolleeEventSummaryListView', 'uEnrolleeEventSummaryListViewHolder',
            {
                'keyField': 'EnrolleeId',
                'keyFieldType': 'number',
                'cssClass': 'VeritracksListView',
                'selectMethod': 'single',
                'scrollIntoView': false,
                'canUnselect': false
            },
            lColumns);
        mControls.ListView.bind('selectedchanged', mEnrolleeEventSummaryListView_OnSelectedChanged, mThis);
        mControls.ListView.bind('update', listView_OnUpdate);
        mControls.ListView.bind('updatenotice', listView_OnUpdateNotice);
        if (!isNullOrUndefined(lViewState)) {
            mControls.ListView.bind('databind', uDashboardListView_OnDataBind, lViewState.Value);
        } else {
            mControls.ListView.bind('databind', dashboardListView_OnDataBind);
            mControls.ListView.bind('columnschanging', uDashboardListView_OnColumnsChanging);
            mControls.ListView.bind('columnschanged', uDashboardListView_OnColumnsChanged);
        }
        mControls.ListView.bind('sort', uDashboardReportListView_OnSort);

        //If there is no enrollee selected, do not allow them to add a note.
        var lItem = mControls.ListView.selectedDataItem();

        if (!isNullOrUndefined(lItem)) {
            $('.DashboardEnrolleeDataItem').show();
        } else {
            $('.DashboardEnrolleeDataItem').hide();
        }
    }

    function uDashboardReportListView_OnSort(aParams, aData) {
        "use strict";
        var lColumns = mData.DataDirty,
            lColumnsListSorted = [],
            lPaginated;

        lColumnsListSorted = aData.sort(lColumns);

        mData.DataDirty = lColumnsListSorted;
        lPaginated = mControls.ListViewPaginator.paginate(lColumnsListSorted);
        mControls.ListView.setDataSource(lPaginated);
    }

    function uEnrolleeEventSummaryFilter_OnFilter(aSender, aExpression, aThis) {
        "use strict";
        var lPredicateBuilder = new SumoPredicateBuilder(),
            lCaseloadExpression = aSender.getColumnExpression('IsMyCaseload');
        setViewState('DandEFilterViewState', true);
        function renderList(aRenderExpression) {
            var lData = generateReport(),
                lSortPredicate = new SortExpression();

            if (!isNullOrUndefined(lData)) {
                lData = query(lData, aRenderExpression);

                if (lData.length == 0){
                    checkForUnconfirmedEventsDashboard(0);
                }else{
                  processAnnoyingLights(lData);
                }

                lSortPredicate.addAscendingColumn('LastName');
                mData.DataDirty = lSortPredicate.sort(lData);
                if (isNullOrUndefined(mControls.ListViewPaginator)) {
                    createDashboardPaginator();
                }
                mData.DataPaginated = mControls.ListViewPaginator.paginate(mData.DataDirty);
                mControls.ListView.setDataSource(mData.DataPaginated);
                mControls.ListView.setUpdated(false);
            }
            $('#uEnrolleesEventSummaryLoadingBar').hide();
            $('#uEnrolleeEventSummaryListViewHolder').show();

            var lListViewTop = $("#uEnrolleeEventSummaryListViewViewPort").scrollTop();
            var lListHeight = $('#uEnrolleeEventSummaryListViewViewPort');
            var lSelected = $(".sumo-data-row-selected");
            if (lListHeight.length > 0) {
                lListHeight = lListHeight[0].scrollHeight;
            }
            mControls.ListView.setColumns(mControls.ListView.getColumns());
            var lListHeightAfter = $('#uEnrolleeEventSummaryListViewViewPort');

            if (lListHeightAfter.length > 0 && lSelected.length > 0) {
                var lListMargin = Math.abs(lListHeight - lListHeightAfter[0].scrollHeight);
                if (lListMargin > 0) {
                    lListViewTop = ((lListViewTop + lSelected.offset().top) + lSelected[0].scrollHeight + 17);
                } else {
                    lListViewTop = (lListViewTop + lSelected.offset().top);
                }

            }
            $("#uEnrolleeEventSummaryListViewViewPort").scrollTop(lListViewTop);
            setScroll();

        }

        function loaded(aSender, aCacheItem, aParams) {
            if (!isNullOrUndefined(mData)) {
                mCache.unbind('FullEnrolleeReportupdated', loaded);
                mData.EventList.push({ 'name': 'FullEnrolleeReportupdated', 'handler': mCache_DataItemLoaded });
                mCache.bind('FullEnrolleeReportupdated', mCache_DataItemLoaded, mThis);

                mCache.unbind('EnrolleeReportupdated', mCache_DataItemLoaded);
                mCache.unbind('EnrolleeReportupdated', dataItem_OnUpdate);
                mCache.RemoveUpdatableItem('EnrolleeReport');
                mCache.bind('FullEnrolleeReportupdated', dataItem_OnUpdate);

                renderList(aParams);
            }
        }

        $('#uEnrolleesEventSummaryLoadingBar').show();
        $('#uEnrolleeEventSummaryListViewHolder').hide();
        var lCheckEmpty = getDataItems('EnrolleeReport');
        if (isNullOrUndefined(lCheckEmpty))
            lCheckEmpty = getDataItems('FullEnrolleeReport');
        if (ObjectLength(lCheckEmpty) == 0 || ((isNullOrUndefined(lCaseloadExpression) || lCaseloadExpression.Value === false || lCaseloadExpression.Value === -1) && !mData.IsFullReportInitialized)) {
            if (gUserDetails.OrganizationIds.length > 0) {
                lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                // this will be renamed: DashboardReportData
            }
            mCache.bind('FullEnrolleeReportupdated', loaded, aExpression);
            initializeDataItem('EnrolleeReport', 'FullEnrolleeReport', gCacheSettings.FullEnrolleeReportUpdateInterval, lPredicateBuilder.RootExpression, false, ['Id', 'OrganizationId', 'MetricId']);
            mData.IsFullReportInitialized = true;
        } else {
            renderList(aExpression);
        }
    }

    function getUniversalDashboardReportProperty(aOrganizationId) {
        "use strict";
        var lStatus = false;
        if (aOrganizationId) {
            if (checkOrganizationProperty(aOrganizationId, 'unconfirmed_event_icon_status') == 'Y') {
                lStatus = true;
            }
        } else {
            for (var lKey in gUserDetails.OrganizationIds) {
                if (checkOrganizationProperty(gUserDetails.OrganizationIds[lKey], 'unconfirmed_event_icon_status') == 'Y') {
                    lStatus = true;
                }
            }
        }

        mData.EventReportIconsStatus = lStatus;
    }

    function createDashboardFilter() {
        "use strict";
        var lUserPreferences = getUserPreferences(6),
            lOptions,
            lRiskLevels = riskLevelsFilter_DataListConverter(),
            lOrganizations,
            lEnrolleesTileViewState = getViewState('DandEFilterViewState'),
            lBuilder = new SumoPredicateBuilder(),
            lKey;

        lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);

        getUniversalDashboardReportProperty();
        lOptions = {
            'Title': localizeWrapper('cEnrolleeFindEnrollees'),
            'Content': '',
            'CssClass': 'ButtonFilter',
            'HideOnFilter': true,
            'Columns': [
            { 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
            { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' },
            { 'Id': 'SecondaryID', 'Title': localizeWrapper('cEnrolleeSecondaryId'), 'Type': 'Text', 'DataField': 'SecondaryId' },
            { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
            { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll'), 'DefaultValue': '' },
            { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeWrapper('cYes') }, { 'Value': false, 'Text': localizeWrapper('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'IsMyCaseload', 'Title': localizeWrapper('cEnrolleeMyCaseload'), 'Type': 'Dropdown', 'DataField': 'IsMyCaseload', 'DataSource': [{ 'Value': true, 'Text': localizeWrapper('cYes') }, { 'Value': false, 'Text': localizeWrapper('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': true, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'RiskLevelId', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevelId', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 6
        };
        var lVictimTabEnabled = veritracks.system.clientSetting('VictimMonitoringEnabled');
        if(lVictimTabEnabled){
            lOptions['Columns'].push({ 'Id': 'EnrolleeType', 'Title':  localizeWrapper('cEnrolleeCaseloadType'), 'Type': 'Dropdown', 'DataField': 'EnrolleeType', 'DataSource': [{ 'Value': 2, 'Text': localizeWrapper('cEnrolleeVictim') }, { 'Value': 1, 'Text': localizeWrapper('cEnrolleeOffender') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'integer', 'InsertBlank': true, 'BlankText': localizeText('cBoth') });
        }
        // still have to figure out how to filter on these items
        //Risk Level
        //My Caseload
        //RF Only (those offenders on BLUbands)
        //GPS Only (those offenders on BLUtag)
        //Open Vios (for simplicity any open events)

        mControls.ListViewFilter = gFilterFactory.createControl(
            'uEnrolleeEventSummaryFilter',
            'uEnrolleeEventSummaryFilterHolder',
            lOptions);

        mControls.ListViewFilter.bind('filter', uEnrolleeEventSummaryFilter_OnFilter, mThis);
        mControls.ListViewFilter.filter();
    }

    function uEnrolleeEventSummaryListViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
        "use strict";
        if (!isNullOrUndefined(mData.DataDirty)) {
            mData.DataPaginated = aSender.paginate(mData.DataDirty);
            mControls.ListView.setDataSource(mData.DataPaginated);
        }
        setViewState('DashboardSelectedPage', aNewPage);
        mControls.ListView.setUpdated(false);
    }

    function createDashboardPaginator() {
        "use strict";
        var lDashboardState = getViewState('DashboardSelectedEnrollee'),
            lPageState = getViewState('DashboardSelectedPage');
        mControls.ListViewPaginator = new sumo.controls.Paginator('uEnrolleeEventSummaryListViewPaginator', 'uEnrolleeEventSummaryListViewPaginatorHolder', {
            'ItemCount': count(mData.DataDirty),
            'ItemsPerPage': gPaginationSettings.DashboardItems
        });

        if (!isNullOrUndefined(lDashboardState) && !isNullOrUndefined(lPageState)) {
            mControls.ListViewPaginator.setPage(lPageState.Value);
        }
        mControls.ListViewPaginator.bind('pagechanged', uEnrolleeEventSummaryListViewPaginator_OnPageChanged);
        resetContentHolders();


    }

    function uEnrolleeSummaryNotesManager_OnWriteSuccess(aEnrolleeId, aData) {
        "use strict";
        var lPredicateBuilder = new SumoPredicateBuilder(),
            lMetricId = 2081, // 2081 == note
            lData = getCacheItem('EnrolleeReport'),
            lFullData = getCacheItem('FullEnrolleeReport'),
            lReport = lData.Data,
            lQuery,
            lItem,
            lFoundHole = false,
            lNewItemId = 0,
            lKey;

        if (!isNullOrUndefined(lFullData)) {
            lData = lFullData;
        }

        lPredicateBuilder.AddNewExpressionConditional('Id', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('MetricId', lMetricId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lQuery = query(lReport, lPredicateBuilder.RootExpression);
        if (count(lQuery) > 0) {
            for (lKey in lQuery) {
                if (lQuery.hasOwnProperty(lKey)) {
                    lQuery[lKey].Value = parseInt(lQuery[lKey].Value) + 1;
                    break;
                }
            }
        } else {
            for (lKey in lReport) {
                if (lReport.hasOwnProperty(lKey)) {
                    // grab an item to extend below
                    lItem = lReport[lKey];
                    break;
                }
            }
            lNewItemId = 0;
            while (!lFoundHole) {
                lNewItemId++;
                lFoundHole = isNullOrUndefined(lReport[lNewItemId]);
            }
            lItem = $.extend({}, lItem);

            lItem.Id = aEnrolleeId;
            lItem.MetricId = lMetricId;
            lItem.DisplayType = 6;
            lItem.Value = 1;
            lReport[lData.getHashValue(lItem)] = lItem;
        }

        mControls.ListViewFilter.filter();

        mActivityNotification.addNotification(localizeWrapper('cEnrolleeSaveNoteFor') + getDataItem(aEnrolleeId, 'Enrollees').FullName);
    }

    function uEnrolleeSummaryNotesManager_OnWriteFailure(aEnrolleeId, b, c, d) {
        "use strict";
        //alert('Could not save note for enrollee: ' + getDataItem(aEnrolleeId, 'Enrollees').FullName);
    }

    function uEnrolleeSummaryNotesManager_OnAdd(aNote) {
        "use strict";
        aNote.EnrolleeId = mControls.ListView.selected();
        WriteSingle(aNote, uEnrolleeSummaryNotesManager_OnWriteSuccess, uEnrolleeSummaryNotesManager_OnWriteFailure, aNote.EnrolleeId);
    }

    function createEnrolleeNoteManager() {
        "use strict";
        mControls.NotesManager = new SumoNotesManager('uEnrolleeSummaryNotesManager', 'uDashboardEnrolleeNoteManagerHolder', [], {
            'ClassName': 'Enrollee', // name of type of note being used, not CSS
            'OnAdd': uEnrolleeSummaryNotesManager_OnAdd,
            'IdentificationProperty': 'EnrolleeId',
            'Identifier': -1,
            'UserId': gUserDetails.UserId
        });
        mControls.NotesManager.RenderContents();
    }
    const PERCENTAGE_METRIC_ID = 4121;
    function generateReport() {
        "use strict";
        var lReport = [],
            lVictimTabEnabled = veritracks.system.clientSetting('VictimMonitoringEnabled'),
            lBuilder = new SumoPredicateBuilder(),
            lSort = new SortExpression(),
            lData = getDataItems('EnrolleeReport'),
            lFullData = getDataItems('FullEnrolleeReport'),
            lAgents = getDataItems('Agents'),
            lEnrollees = getDataItems('Enrollees'),
            lEvents = getDataItems('Events'),
            lBluTagRF = [],
            lItem = null,
            lColumn = null,
            lDefaultColumns = [],
            lKey,
            lColumnKey,
            lRow = null,
            lColumnData = null,
            lSortPredicate = new SortExpression(),
            lLastEnrolleeId = -1,
            lAgentKey,
            lEnrolleeKey,
            lEnrollee = null,
            lAgent = null,
            lMyAgents,
            lMyAgentIds = [],
            lClosedRed = false,
            lListEnrolleeIds = [],
            lListColumnIds = [],
            lOpenRed = false,
            unconfirmedEventCounter = 0,
            eventsCheck = null;

        if (!isNullOrUndefined(lFullData)) {
            lData = lFullData;
        }

        lSortPredicate.addAscendingColumn('Id');
        lData = lSortPredicate.sort(lData);

        lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lMyAgentIds = getMyAgentIds(gUserDetails.UserId);

        lColumnData = getDataItems('EnrolleeReportColumn');
        for (lColumnKey in lColumnData) {
            if (lColumnData.hasOwnProperty(lColumnKey)) {
                lDefaultColumns[lColumnData[lColumnKey].Id] = null;
            }
        }

        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                lItem = lData[lKey];
                if (lItem.MetricId == 9999) {
                    var l = '';
                }
                if (lLastEnrolleeId !== lItem.Id) {
                    lLastEnrolleeId = lItem.Id;
                    lRow = {};
                    lRow = $.extend({}, lDefaultColumns);
                    if(!lRow.GroupId){
                      lRow.GroupId = [];
                      lRow.EventCount = 0;
                    }
                    if (!isNullOrUndefined(lEnrollees)) {
                        lEnrollee = lEnrollees[lItem.Id];
                    }
                   
                    if (!isNullOrUndefined(lEnrollee)) {

                        if (lEnrollee.EnrolleeType == 1 || lVictimTabEnabled && lEnrollee.EnrolleeType == 2) {
                            lRow.EnrolleeId = lItem.Id;
                            lRow.FullName = lEnrollee.FullName;
                            lRow.LastName = lEnrollee.LastName;
                            lRow.AgentId = lEnrollees[lRow.EnrolleeId].AgentId;
                            lRow.PrimaryId = lEnrollee.PrimaryId;
                            lRow.SecondaryId = lEnrollee.SecondaryId;
                            lRow.IsAssigned = lEnrollee.IsAssigned;
                            eventsCheck = checkOpenEvents(lEnrollee, lEvents);
                            lRow[4002] = dashboardSummaryReportIconBluPlus(eventsCheck);
                            lRow[200] = mThis.dashboardSummaryReportIconAlcohol(lEnrollee.Id);
                            lRow.IsMyCaseload = (lMyAgentIds.indexOf(lEnrollee.AgentId) !== -1);
                            lRow.EnrolleeType = lEnrollee.EnrolleeType;
                            lAgent = lAgents[lEnrollee.AgentId];
                            if (!isNullOrUndefined(lAgent)) {
                                lRow.AgentName = lAgent.FullName;
                            }
                            else {
                                lRow.AgentName = 'Unknown';
                            }
                            lRow.OrganizationId = lEnrollee.OrganizationId;
                            lRow.RiskLevelId = lEnrollee.RiskLevelId;
                            lReport.push(lRow);
                        }
                    }
                }
                lColumn = lColumnData[lItem.MetricId];
                if (!isNullOrUndefined(lColumn) && !isNullOrUndefined(lEnrollee)) {
                    if (lRow.OrganizationId == lItem.OrganizationId) {
                        switch (lColumn.DisplayType) {
                            case 1:
                                if (lRow.IsAssigned) {
                                    var lVal = parseInt(lItem.Value);
                                    if (lVal == 2) {
                                        lRow.EventCount++;
                                    } else if (lVal == 1 || lVal == 3) {
                                        lRow.GroupId.push(lColumn.Id);
                                    }
                                }
                                if (lColumn.Id != 200) {
                                    lRow[lColumn.Id] = dashboardSummaryReportIcon(lItem, lColumn.Id, lEnrollee.Id);
                                }


                                break;
                            case 2:
                                lRow[lColumn.Id] = inventoryBatteryLevelFormatter(lItem.Value);
                                break;
                            case 3:
                                lRow[lColumn.Id] = dashboardSummaryReportDate(lEnrollee.Id, lItem.Value);
                                break;
                            case 4:
                                // MetricId 4121 represents a percentage value that needs % symbol appended
                                if(lItem.MetricId == PERCENTAGE_METRIC_ID){
                                    lRow[lColumn.Id] = lItem.Value? lItem.Value + '%': '';
                                } else {
                                    lRow[lColumn.Id] = lItem.Value;
                                }
                                break;
                            case 5:
                                lRow[lColumn.Id] = EnrolleeRiskLevelFormatter(lItem.Value);
                                break;
                            case 6:
                                lRow[lColumn.Id] = notesCountPopUpFormatter(lItem.Value, lEnrollee.Id);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
        return lReport;
    }

    // function to display bluplus checkin status
    function dashboardSummaryReportIconBluPlus(aEventsCheck) {
        "use strict";
        var lOrganization,
            lResult = [],
            lClass = 0;

        lResult.push('<div class="GridIcon');
        if (!isNullOrUndefined(aEventsCheck)) {
            lClass = 20 + aEventsCheck * 1000;
            lResult.push(' EventState');
            lResult.push(lClass.toWholeString(4));
        }
        lResult.push('"></div><span class="GridIconText">');
        lResult.push('</span>');

        return lResult.join('');
    }

    // function to check events for enrollee id returns true if blu+ check in event occurs
    function checkOpenEvents(aEnrollee, aEvents) {
        "use strict";
        if (bluPlusCheck(aEnrollee.Id)) {
            if (!isNullOrUndefined(aEvents)) {
                var lkey,
                eventCounter = 0,
                lEvents = aEvents,
                lPredicateBuilder = new SumoPredicateBuilder();

                lPredicateBuilder.AddNewExpressionConditional('EnrolleeId', aEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lEvents = query(lEvents, lPredicateBuilder.RootExpression);
                if (lEvents.length > 0) {
                    for (lkey in lEvents) {
                        // 406 = late arrival, 407 unknown location
                        if (lEvents[lkey].MetaEventId == 406 || lEvents[lkey].MetaEventId == 407) {
                            if (lEvents[lkey].IsConfirmed) {
                                if (lEvents[lkey].IsOpen) {
                                    eventCounter = 1;
                                }
                                else {
                                    eventCounter = 0;
                                }
                            }
                            else {
                                if (lEvents[lkey].IsOpen) {
                                    eventCounter = 2;
                                }
                                else {
                                    eventCounter = 1;
                                }
                            }
                        }
                    }
                }
                return eventCounter;
            }
        }
    }
    function this_OnDataLoadComplete() {
        // create the list view
        createEnrolleeEventSummaryListView();
        createDashboardFilter();
        createDashboardPaginator();
        createEnrolleeNoteManager();
        createDashboardReportSelect();

        renderComplete();
    }




    function mCache_DataItemLoaded(aParams, aCacheItem, aThis) {
        "use strict";
        mCache.unbind(aCacheItem.Name + 'updated', mCache_DataItemLoaded);
        if (mData.PendingDataItemCount-- === 0) {
            mData.IsDataIntitialized = true;

            // the data is now loaded
            this_OnDataLoadComplete();

            // hide the splash screen
            hideLoadingScreen();

            mThis.trigger('initialized');
        }
    }

    function initializeDataItem_OnFailure(aParams, a, b, c) {
    }

    function initializeDataItem(aObjectType, aCacheName, aUpdateIntervalInSeconds, aExpression, aDoFixDates, aHashColumns) {
        "use strict";
        if (mThis.isNothing(getCacheItem(aCacheName + 'updated'))) {
            var lType;
            if (!isNullOrUndefined(gObjectList[aObjectType])) {
                lType = gObjectList[aObjectType].AssemblyQualifiedName;
            } else {
                lType = 'Veritracks.Core.' + aObjectType + ', Veritracks.Core';
            }
            mData.EventList.push({ 'name': aCacheName + 'updated', 'handler': hideNotification });
            mData.CacheList.push(aCacheName);
            mCache.bind(aCacheName + 'updated', hideNotification, mActivityNotification.addNotification(localizeWrapper('cEnrolleeLoading') + aCacheName + '.', null, gSystemSettings.IsDebug));
            mCache.AddUpdatableItem(aCacheName, lType, aExpression, aUpdateIntervalInSeconds, initializeDataItem_OnFailure, null, aDoFixDates, aHashColumns);
        }
    }

    function mCache_SystemMessageOrganizationUpdated(aParams, aCacheItem, aThis) {
        mCache.unbind('SystemMessageOrganizationupdated', mCache_SystemMessageOrganizationUpdated);

        var lSystemMessageIds = getIdArray(aCacheItem, 'Id'),
            lPredicateBuilder = new SumoPredicateBuilder();

        mData.EventList.push({ 'name': 'SystemMessageupdated', 'handler': mCache_SystemMessageUpdated });
        mCache.bind('SystemMessageupdated', mCache_SystemMessageUpdated, aThis);
        mData.EventList.push({ 'name': 'SystemMessageupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('SystemMessageupdated', mCache_DataItemLoaded, aThis);

        // this is a hack to work around the server side predicate builder
        if (lSystemMessageIds.length === 0) {
            lSystemMessageIds.push(-1);
        }
        lPredicateBuilder.AddNewExpressionConditional('Id', lSystemMessageIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        initializeDataItem('SystemMessage', 'SystemMessage', gCacheSettings.SystemMessageUpdateInterval, lPredicateBuilder.RootExpression, true);
    }

    function mCache_DashboardReportUpdated(aParams, aCacheItem, aThis) {
        "use strict";
        mCache.unbind('DashboardReportupdated', mCache_DashboardReportUpdated);

        var lDashboardReportIds = getIdArray(aCacheItem, 'Id'),
            lPredicateBuilder = new SumoPredicateBuilder();

        mData.EventList.push({ 'name': 'DashboardReportColumnupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('DashboardReportColumnupdated', mCache_DataItemLoaded, aThis);

        lPredicateBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if (lDashboardReportIds.length > 0) {
            lPredicateBuilder.AddNewExpressionConditional('DashboardReportId', lDashboardReportIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        } else {
            lPredicateBuilder.AddNewExpressionConditional('DashboardReportId', -1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        initializeDataItem('DashboardReportColumn', 'DashboardReportColumn', gCacheSettings.DashboardReportColumnsUpdateInterval, lPredicateBuilder.RootExpression, false);
        //}  breeaks...wont load dashboard if initialize doesn't occur
    }

    function initializeDataLoad() {
        var lPredicateBuilder = new SumoPredicateBuilder(),
            lMyAgentIds = getMyAgentIds(gUserDetails.UserId),
            lEnrollees = getDataItems('Enrollees'),
            lEnrolleeIds = [],
            lItem,
            lKey;

        lPredicateBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
       // initializeDataItem('EnrolleeTile', 'EnrolleeTile', gCacheSettings.EnrolleeTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('EventTile', 'EventTile', gCacheSettings.EventTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('ZoneTile', 'ZoneTile', gCacheSettings.ZoneTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('AnalysisTile', 'AnalysisTile', gCacheSettings.AnalysisTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('ReportTile', 'ReportTile', gCacheSettings.ReportTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('InventoryTile', 'InventoryTile', gCacheSettings.InventoryTileUpdateInterval, lPredicateBuilder.RootExpression, false);
        //initializeDataItem('AgentTile', 'AgentTile', gCacheSettings.AgentTileUpdateInterval, lPredicateBuilder.RootExpression, false);
       // initializeDataItem('UserTile', 'UserTile', gCacheSettings.UserTileUpdateInterval, lPredicateBuilder.RootExpression, false);

        mData.EventList.push({ 'name': 'SystemMessageOrganizationupdated', 'handler': mCache_SystemMessageOrganizationUpdated });
        mCache.bind('SystemMessageOrganizationupdated', mCache_SystemMessageOrganizationUpdated, mThis);
        mData.EventList.push({ 'name': 'DashboardReportupdated', 'handler': mCache_DashboardReportUpdated });
        mCache.bind('DashboardReportupdated', mCache_DashboardReportUpdated, mThis);

        mData.EventList.push({ 'name': 'SystemMessageOrganizationupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('SystemMessageOrganizationupdated', mCache_DataItemLoaded, mThis);
        mData.EventList.push({ 'name': 'DashboardReportupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('DashboardReportupdated', mCache_DataItemLoaded, mThis);
        mData.EventList.push({ 'name': 'EnrolleeReportupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('EnrolleeReportupdated', mCache_DataItemLoaded, mThis);
        mData.EventList.push({ 'name': 'EnrolleeReportColumnupdated', 'handler': mCache_DataItemLoaded });
        mCache.bind('EnrolleeReportColumnupdated', mCache_DataItemLoaded, mThis);
        // this will be renamed: DashboardReportColumn
        initializeDataItem('EnrolleeReportColumn', 'EnrolleeReportColumn', gCacheSettings.EnrolleeReportColumnUpdateInterval, null, false);

        lPredicateBuilder.Clear();
        lPredicateBuilder.AddNewExpressionConditional('AgentId', lMyAgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEnrollees = query(lEnrollees, lPredicateBuilder.RootExpression);
        for (lKey in lEnrollees) {
            if (lEnrollees.hasOwnProperty(lKey)) {
                lItem = lEnrollees[lKey];
                lEnrolleeIds.push(lItem.Id);
            }
        }
        lPredicateBuilder.Clear();
        if (lEnrolleeIds.length > 0) {
            lPredicateBuilder.AddNewExpressionConditional('Id', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        } else {
            lPredicateBuilder.AddNewExpressionConditional('Id', -99999, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        if (gUserDetails.OrganizationIds.length > 0) {
            lPredicateBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            // this will be renamed: DashboardReportData
        }
        initializeDataItem('EnrolleeReport', 'EnrolleeReport', gCacheSettings.EnrolleeReportUpdateInterval, lPredicateBuilder.RootExpression, false, ['Id', 'OrganizationId', 'MetricId']);
        mCache.bind('EnrolleeReportupdated', dataItem_OnUpdate);
        initializeDataItem('SystemMessageOrganization', 'SystemMessageOrganization', gCacheSettings.SystemMessageUpdateInterval, lPredicateBuilder.RootExpression);

        lPredicateBuilder.Clear();

        lPredicateBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // this will be renamed: DashboardReportView
        initializeDataItem('DashboardReport', 'DashboardReport', gCacheSettings.DashboardReportUpdateInterval, lPredicateBuilder.RootExpression, false);
    }

    function hideColumnSelect() {
        "use strict";
        mData.IsExpanderVisible = false;
        //$('#uColumnListViewPanel').fadeOut();
        //mControls.ColumnsDropdown.hide();
        if (!isNullOrUndefined(mControls.ReportColumnValidator)) {
            mControls.ReportColumnValidator.dispose();
            mControls.ReportColumnValidator = null;
        }

    }

    function showColumnSelect(aEvent) {
        "use strict";
        var //lPanel = $('#uColumnListViewPanel'),
            lSelect = $('#uEnrolleeEventSummaryCustomReportSelect');
        mControls.ReportColumnValidator = new Validator('uColumnListViewPanel', mRegexValidation);
        mData.IsExpanderVisible = true;
        //lPanel[0].style.left = (aEvent.pageX - (lPanel.width() + 20)) + 'px';
        $('#uReportNameText').val('');
        $('#uUniversalSearchText').focus(); // anchor here first -- appears to be a chrome bug.
        mControls.ColumnsListView.selected(getReportColumnIds(lSelect.val()));
        //lPanel.fadeIn();
        mControls.ColumnsListView.resize();
        mControls.ColumnsListView.resizeColumns();
        mControls.ReportColumnValidator.AutoFillVerify($("#uReportNameText"));
    }

    function toggleColumnSelection(aEvent) {
        "use strict";
        if (mData.IsExpanderVisible) {
            hideColumnSelect();
        } else {
            showColumnSelect(aEvent);
        }
    }

    function saveColumnList_OnWriteSuccess(aReport, aData) {
        "use strict";
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeSaveCustomReport') + aReport.Description);
        var lItem,
            i,
            lLength = aData.length,
            lData;;

        lData = getDataItems('DashboardReportColumn');
        for (i = 0; i < lLength; i++) {
            lItem = aData[i];
            // need to get unique id.... otherwise will erase previously created dashboard report from cache.
            lData[lItem.Id] = lItem;
        }
        createDashboardReportSelect();
        $('#uEnrolleeEventSummaryCustomReportSelect').val(aReport.Id)
                                                     .trigger('change');
        mControls.ColumnsDropdown.hide();
    }

    function saveColumnList_OnWriteFailure(aReport, b, c, d) {
        // alert('Could not save report group columns: ' + aReport.Description);
    }

    function saveColumnReport_OnWriteSuccess(aDescription, aData) {
        "use strict";
        var i,
            lColumn,
            lColumnList = [],
            lSelectedColumns = mControls.ColumnsListView.selected(),
            lLength = lSelectedColumns.length;
        for (i = 0; i < lLength; i++) {
            lColumn = new DashboardReportColumn(gUserDetails.UserId, aData.Id, lSelectedColumns[i], i);
            lColumnList.push(lColumn);
        }
        WriteMultiple(lColumnList, saveColumnList_OnWriteSuccess, saveColumnList_OnWriteFailure, aData);
    }

    function saveColumnReport_OnWriteFailure(aDescription, b, c, d) {
        "use strict";
        //alert('Could not save report group: ' + aDescription);
    }

    function saveColumnSelection() {
        "use strict";
        if (mControls.ReportColumnValidator.IsValid()) {
            hideColumnSelect();
            //Vulnerability 3259
            var lDescription = veritracks.system.encodeHtml($('#uReportNameText').val()),
                lSortOrder = $('#uSortReport'),
            lReport = new DashboardReport(gUserDetails.UserId, lDescription);

            if (lSortOrder.prop('checked')) {
                WriteSingle(lReport, SortReport_onChecked, saveColumnReport_OnWriteFailure, lDescription);
            }
            else {
                WriteSingle(lReport, saveColumnReport_OnWriteSuccess, saveColumnReport_OnWriteFailure, lDescription);
            }
        }
    }

    function SortReport_OnClick() {
        "use strict";
        var lSortOrder = $('#uSortReport');

        if (lSortOrder.prop('checked')) {
            $('#uColumnDefinitionSave').removeClass('SaveButton');
            $('#uColumnDefinitionSave').addClass('SortButton');
            $('#uColumnDefinitionSave').text(localizeText('cSort'));
        }
        else {
            $('#uColumnDefinitionSave').removeClass('SortButton');
            $('#uColumnDefinitionSave').addClass('SaveButton');
            $('#uColumnDefinitionSave').text(localizeText('cEnrolleeSave'));
        }
    }

    function uChangeSortOrder_OnChange() {
        "use strict";
    }

    function uSortReport_OnSave() {
        "use strict";
        var lData = mControls.SortReportListView.getDataSource(),
            lReportData = gDashboardPage.getReportData(),
            lKey;

        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                delete lData[lKey].Description;
            }
        }
        mControls.SortReportListView.dispose();
        mControls.SortReportListView = null;
        WriteMultiple(lData, saveColumnList_OnWriteSuccess, saveColumnList_OnWriteFailure, lReportData);
        ClosePopup();
    }
    function SortReport_onChecked(aDescription, aData) {
        "use strict";
        var lSelectedColumns = mControls.ColumnsListView.selected(),
            lLength = lSelectedColumns.length,
            lButtonBar = GenerateButtonCommandBar(),
            lBuilder = new SumoPredicateBuilder(),
            lData,
            lColumn,
            lDashboardReportData = [],
            lKey,
            i = 0;

        lBuilder.AddNewExpressionConditional('Id', lSelectedColumns, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lData = query(getDataItems('EnrolleeReportColumn'), lBuilder.RootExpression);

        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                lColumn = new DashboardReportColumn(gUserDetails.UserId, aData.Id, lData[lKey].Id, i);
                lColumn.Description = lData[lKey].Description;
                lDashboardReportData.push(lColumn);
                i++;
            }
        }

        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', uSortReport_OnSave));
        DisplayPopup(aDescription, '<div id="uSortReportListViewHolder" style="height: 280px;"></div>', lButtonBar, true);
        if (!isNullOrUndefined(mControls.SortReportListView)) {
            mControls.SortReportListView.dispose();
            mControls.SortReportListView = null;
        }
        mControls.SortReportListView = new sumo.controls.ListView('uSortReportListView', 'uSortReportListViewHolder', { 'keyField': 'SortOrder', 'selectMethod': 'single', 'cssClass': 'VeritracksSelectListView', 'canUnselect': false, 'showHeader': true }, [
            { 'id': 'SortIcon', 'title': localizeWrapper('cDashboardUpDown'), 'dataField': 'SortOrder', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': SortOrderFormatter },
                { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': ReportColumnFormatter },
        { 'id': 'SortOrder', 'title': localizeWrapper('cDashboardSortOrder'), 'dataField': 'SortOrder', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
        ]);

        mControls.SortReportListView.setDataSource(lDashboardReportData);
        mControls.SortReportListView.bind('selectedchanged', uChangeSortOrder_OnChange);
        gDashboardPage.ReportData(aData);

    }
    function SortOrderFormatter(aValue) {
        "use strict";
        var lHtml = [];

        lHtml.push('<div>');
        lHtml.push('<div class="SortUpIcon StopClickBubble" style="padding: 5px; float:left"');
        lHtml.push(' onclick="gDashboardPage.SortUp(');
        lHtml.push(aValue);
        lHtml.push(')"> </div>');
        lHtml.push('<div class="SortDownIcon StopClickBubble" style=" padding: 5px; float:right"');
        lHtml.push(' onclick="gDashboardPage.SortDown(');
        lHtml.push(aValue);
        lHtml.push(')"> </div>');
        lHtml.push('</div>');

        return lHtml.join('');
    }

    this.ReportData = function (aData) {
        mData.ReportData = aData;
    }
    this.getReportData = function () {
        return mData.ReportData;
    }

    this.setAlcoholData = function (aData) {
        mData.AlcoholLastImage = aData;
    }

    this.getAlcoholData = function () {
        return mData.AlcoholLastImage;
    }

    this.SortUp = function (aValue) {
        if (aValue != 0) {
            mControls.SortReportListView.setDataSource(mControls.SortReportListView.SortUp(aValue));
            mControls.SortReportListView.selected(aValue - 1);
        }
    }

    this.SortDown = function (aValue) {
        var lData = mControls.SortReportListView.getDataSource();

        if (aValue < lData.length - 1) {
            mControls.SortReportListView.setDataSource(mControls.SortReportListView.SortDown(aValue));
            mControls.SortReportListView.selected(aValue + 1);
        }
    }
    this.resize = function () {
        if (!isNullOrUndefined(mControls.ColumnsListView)) {
            mControls.ColumnsListView.resize();
        }
    };

    this.triggerOnFilter = function () {
        if (!isNullOrUndefined(mControls.ListViewFilter)) {
            mControls.ListViewFilter.filter();
        }
    };

    function columnsDropdown_OnOpened() {
        mControls.ColumnsListView.resizeColumns();
    }


    this.render = function () {
        // inititialize data load
        if (!mData.IsDataIntitialized) {
            initializeDataLoad();
            createTiles();
        } else {
            // on data initialized
            //  create listview
            //  create cardview
            //  create filter
            //  execute filter
            createTiles();
            this_OnDataLoadComplete();
        }
        mControls.ColumnsDropdown = new sumo.controls.Dropdown('DashboardColumnsButton', 'uDashboardColumnsHeaderHolder', {
            'title': localizeWrapper('cColumns'),
            'viewportType': 'inline',
            'contentType': 'jQueryElement',
            'isOpen': false,
            'cssClass': 'DashboardColumns',
            'content': $('#uColumnListViewPanel')
        });

        mControls.ColumnsDropdown.bind('opened', showColumnSelect);
        mControls.ColumnsDropdown.bind('closed', hideColumnSelect);
        // hide splash screen : mCache_DataItemLoaded
        displayUserAgreement();

    };

    function redrawEventSummaryTable() {
        "use strict";
        mData.ConfirmStepCount--;
        if (mData.ConfirmStepCount === 0) {
            // trigger redraw of table
            mControls.ListViewFilter.filter();
        }
    }

    function confirmNote_OnWriteFailure(aEnrollee, b, c, d) {
        "use strict";
        mData.ConfirmStepCount--;
        //alert('failed to write event confirmation notes for ' + aEnrollee.FullName);
    }

    function confirmNote_OnWriteSuccess(aEnrollee, aData) {
        "use strict";
        redrawEventSummaryTable();
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeConfirmationEventNotes') + aEnrollee.FullName);
    }

    function confirm_OnWriteFailure(aEnrollee, b, c, d) {
        "use strict";
        mData.ConfirmStepCount--;
        // alert('failed to confirm events for ' + aEnrollee.FullName);
    }

    function evaluateEnrolleReportEvent(aMetricId, aEventList) {
        "use strict";
        var lResult = 0,
            lIsConfirmed = true,
            lIsClosed = true,
            lDebugObject = {},
            lItem,
            lKey;

        lDebugObject['Confirmed'] = [];
        lDebugObject['Open'] = [];
        for (lKey in aEventList) {
            if (aEventList.hasOwnProperty(lKey)) {
                lItem = aEventList[lKey];
                if (lIsConfirmed) {
                    lIsConfirmed = lItem.IsConfirmed;
                }
                if (lIsClosed) {
                    lIsClosed = !lItem.IsOpen;
                }

                // debug data
                if (!lItem.IsConfirmed) {
                    lDebugObject['Confirmed'].push(lItem);
                }
                if (lItem.IsOpen) {
                    lDebugObject['Open'].push(lItem);
                }
            }
        }

        if (lIsClosed && lIsConfirmed) {
            lResult = 0;
        } else if (lIsClosed && !lIsConfirmed) {
            lResult = 1;
        } else if (!lIsClosed && !lIsConfirmed) {
            lResult = 2;
        } else if (!lIsClosed && lIsConfirmed) {
            lResult = 3;
        }
        lDebugObject['Id'] = aMetricId;
        lDebugObject['Value'] = lResult;
        mData.EventDebug[aMetricId] = lDebugObject;

        return lResult.toString();
    }

    function evaluateEnrolleeReportMetric(aMetricId, aEventList) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lMetricMetaEvents = getDataItems('MetricMetaEvent'),
            lMetricMetaEventQuery,
            lMetaEventIds = [],
            lEventQuery,
            lItem,
            lKey;

        //lBuilder.AddNewExpressionConditional('MetricId', aMetricId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('Id', aMetricId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lMetricMetaEventQuery = query(lMetricMetaEvents, lBuilder.RootExpression);

        for (lKey in lMetricMetaEventQuery) {
            if (lMetricMetaEventQuery.hasOwnProperty(lKey)) {
                lItem = lMetricMetaEventQuery[lKey];
                lMetaEventIds.push(lItem.MetaEventId);
            }
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('MetaEventId', lMetaEventIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEventQuery = query(aEventList, lBuilder.RootExpression);
        return evaluateEnrolleReportEvent(aMetricId, lEventQuery);
    }

    function recalculateEnrolleeReportEvents(aEnrollee) {
        "use strict";
        var lBuilder = new SumoPredicateBuilder(),
            lEnrolleeReport = getDataItems('EnrolleeReport'),
            lFullEnrolleeReport = getDataItems('FullEnrolleeReport'),
            lEvents = getDataItems('Events'),
            lHashBase = aEnrollee.Id + '.' + aEnrollee.OrganizationId + '.',
            lStartDate = new Date(),
            lDataItemWrite = [],
            lDataItem,
            lValue;

        if (!isNullOrUndefined(lFullEnrolleeReport)) {
            lEnrolleeReport = lFullEnrolleeReport;
        }

        lStartDate.setUTCHours(0);
        lStartDate.setUTCMinutes(0);
        lStartDate.setUTCSeconds(0);
        lStartDate.setUTCMilliseconds(0);
        lStartDate.addDays(-7);
        lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
      //  lBuilder.AddNewExpressionConditional('StartDateUTC', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lEvents = query(lEvents, lBuilder.RootExpression);

        // Bstp - 21
        lDataItem = lEnrolleeReport[lHashBase + '21.'];
        lValue = evaluateEnrolleeReportMetric(21, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // Lbatt - 31
        lDataItem = lEnrolleeReport[lHashBase + '31.'];
        lValue = evaluateEnrolleeReportMetric(31, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // IZ - 51
        lDataItem = lEnrolleeReport[lHashBase + '51.'];
        lValue = evaluateEnrolleeReportMetric(51, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // I911 - 61
        lDataItem = lEnrolleeReport[lHashBase + '61.'];
        lValue = evaluateEnrolleeReportMetric(61, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // IZS - 71
        lDataItem = lEnrolleeReport[lHashBase + '71.'];
        lValue = evaluateEnrolleeReportMetric(71, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // EZ - 111
        lDataItem = lEnrolleeReport[lHashBase + '111.'];
        lValue = evaluateEnrolleeReportMetric(111, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // E911 - 121
        lDataItem = lEnrolleeReport[lHashBase + '121.'];
        lValue = evaluateEnrolleeReportMetric(121, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // EZS - 131
        lDataItem = lEnrolleeReport[lHashBase + '131.'];
        lValue = evaluateEnrolleeReportMetric(131, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // All IZ - 151
        lDataItem = lEnrolleeReport[lHashBase + '151.'];
        lValue = evaluateEnrolleeReportMetric(151, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // All EZ - 161
        lDataItem = lEnrolleeReport[lHashBase + '161.'];
        lValue = evaluateEnrolleeReportMetric(161, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // All EZ - 171
        lDataItem = lEnrolleeReport[lHashBase + '171.'];
        lValue = evaluateEnrolleeReportMetric(171, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        // Other Events - 9999
        lDataItem = lEnrolleeReport[lHashBase + '9999.'];
        lValue = evaluateEnrolleeReportMetric(9999, lEvents);
        if (!isNullOrUndefined(lDataItem) && lDataItem.Value !== lValue) {
            lDataItem.Value = lValue;
            lDataItemWrite.push(lDataItem);
        }

        if (lDataItemWrite.length > 0) {
            WriteMultiple(lDataItemWrite, null, null, null, false);
        }

        if (gSystemSettings.IsDebug) {
            var lMetricMetaEvents = getDataItems('EventGroup'),
                lHtml = [],
                lItem,
                lItem2,
                lKey,
                lKey2;
            lHtml.push('<div style="height: 400px; overflow: auto;">');
            for (lKey in mData.EventDebug) {
                if (mData.EventDebug.hasOwnProperty(lKey)) {
                    lItem = mData.EventDebug[lKey];
                    lHtml.push('<h2><div style="float:left;">');
                    lHtml.push(dashboardSummaryReportIcon({ 'OrganizationId': aEnrollee.OrganizationId, 'Value': lItem.Value }));
                    lHtml.push('</div>');
                    lHtml.push(lMetricMetaEvents[lItem.Id].Description);
                    lHtml.push(' (metric: ' + lItem.Id + ') (value: ' + lItem.Value + ')</h2>');
                    lHtml.push('<h3 style="margin-left: 31px; clear: both;">'+ localizeText('cEventNotConfirmed2')+'</h3>');
                    for (lKey2 in lItem.Confirmed) {
                        if (lItem.Confirmed.hasOwnProperty(lKey2)) {
                            lItem2 = lItem.Confirmed[lKey2];
                            lHtml.push('<div style="margin-left: 46px;">Event ' + lItem2.Id + '</div>');
                        }
                    }
                    lHtml.push('<h3 style="margin-left: 31px;">Not Closed</h3>');
                    for (lKey2 in lItem.Open) {
                        if (lItem.Open.hasOwnProperty(lKey2)) {
                            lItem2 = lItem.Open[lKey2];
                            lHtml.push('<div style="margin-left: 46px;">Event ' + lItem2.Id + '</div>');
                        }
                    }
                }
            }
            lHtml.push('</div>');
            DisplayPopup('Dashboard Debug', lHtml.join(''), '', false);
        }
    }

    this.refreshDashboardReport = function () {
        mControls.ListViewFilter.filter();
    };

    this.xxxxxx = function () {
        var lRow = mControls.ListView.selectedDataItem(),
            lEnrollee = getDataItem(lRow.EnrolleeId, 'Enrollees');

        recalculateEnrolleeReportEvents(lEnrollee);
        mControls.ListViewFilter.filter();
    };

    function confirm_OnWriteSuccess(aEnrollee, aData) {
        "use strict";
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeConfirmedEventsFor') + aEnrollee.FullName);
        var i,
            lItem,
            lLength = aData.length,
            lEvents = getDataItems('Events');
        FixDates(aData);
        for (i = 0; i < lLength; i++) {
            lItem = aData[i];
            lEvents[lItem.Id] = lItem;
        }
        recalculateEnrolleeReportEvents(aEnrollee);
        redrawEventSummaryTable();
    }


    function addNote_ButtonClick() {
        "use strict";
        if (!$('.EventsAddNoteButton').hasClass('Disabled')) {
            var lKey,
    //            lEvent,
                lLocalEvent = null,
                lEvents = getDataItems('Events'),
    //            lEventsToWrite = [],
                lNotesToWrite = [],
                lOriginalNote = null,
                lNote = null,
                lNoteText = $('#uEventNoteText').val(),
                lPredicateBuilder = new SumoPredicateBuilder();

            if (mControls.EventsListView.selected() !== null && mControls.EventsListView.selected().length > 0) {
                if ($.trim(lNoteText) !== '') {
                    lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
                    lOriginalNote.__type = 'Event' + lOriginalNote.__type;
                }

                lPredicateBuilder.AddNewExpressionConditional('Id', mControls.EventsListView.selected(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                lEvents = query(lEvents, lPredicateBuilder.RootExpression);
                for (lKey in lEvents) {
                    if (lEvents.hasOwnProperty(lKey)) {
                        lLocalEvent = lEvents[lKey];
                        //                    lEvent = $.extend({}, lLocalEvent);
                        //                    lEvent.IsConfirmed = true;
                        //                    lEvent.ConfirmedByUserId = gUserDetails.UserId;
                        //                    lEvent.ConfirmedDateUTC = new Date();
                        //                    lEventsToWrite.push(prepareObjectForWcf(lEvent));
                        if (lOriginalNote !== null) {
                            lNote = $.extend({}, lOriginalNote);
                            lNote.EventId = lLocalEvent.Id;
                            lNotesToWrite.push(lNote);
                        }
                    }
                }
                mData.ConfirmStepCount = 0;
                //            if (lEventsToWrite.length > 0) {
                //                mData.ConfirmStepCount++;
                //            }
                if (lNotesToWrite.length > 0) {
                    mData.ConfirmStepCount++;
                }
                //            if (lEventsToWrite.length > 0) {
                //                WriteMultiple(lEventsToWrite, confirm_OnWriteSuccess, confirm_OnWriteFailure, mControls.EventsListView.data);
                //            }
                if (lNotesToWrite.length > 0) {
                    WriteMultiple(lNotesToWrite, confirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, mControls.EventsListView.data);
                }
            }
            ClosePopup();
        }
    }
    this.confirmEventsDialog_OkButtonClick = function () {
        "use strict";
        var lKey,
            lEvent,
            lLocalEvent = null,
            lEvents = getDataItems('Events'),
            lEventsToWrite = [],
            lNotesToWrite = [],
            lOriginalNote = null,
            lNote = null,
            lNoteText = $('#uEventNoteText').val(),
            lPredicateBuilder = new SumoPredicateBuilder();

        if (mControls.EventsListView.selected() !== null && mControls.EventsListView.selected().length > 0) {
            if ($.trim(lNoteText) !== '') {
                lOriginalNote = new Note(gUserDetails.UserId, lNoteText);
                lOriginalNote.__type = 'Event' + lOriginalNote.__type;
            }

            lPredicateBuilder.AddNewExpressionConditional('Id', mControls.EventsListView.selected(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lEvents = query(lEvents, lPredicateBuilder.RootExpression);
            for (lKey in lEvents) {
                if (lEvents.hasOwnProperty(lKey)) {
                    lLocalEvent = lEvents[lKey];
                    lEvent = $.extend({}, lLocalEvent);
                    lEvent.IsConfirmed = true;
                    lEvent.ConfirmedByUserId = gUserDetails.UserId;
                    lEvent.ConfirmedDateUTC = new Date();
                    lEvent.__type = "Event:www.veritracks.com";
                    lEventsToWrite.push(prepareObjectForWcf(lEvent));
                    if (lOriginalNote !== null) {
                        lNote = $.extend({}, lOriginalNote);
                        lNote.EventId = lEvent.Id;
                        lNotesToWrite.push(lNote);
                    }
                }
            }
            mData.ConfirmStepCount = 0;
            if (lEventsToWrite.length > 0) {
                mData.ConfirmStepCount++;
            }
            if (lNotesToWrite.length > 0) {
                mData.ConfirmStepCount++;
            }
            if (lEventsToWrite.length > 0) {
                WriteMultiple(lEventsToWrite, confirm_OnWriteSuccess, confirm_OnWriteFailure, mControls.EventsListView.data);
            }
            if (lNotesToWrite.length > 0) {
                WriteMultiple(lNotesToWrite, confirmNote_OnWriteSuccess, confirmNote_OnWriteFailure, mControls.EventsListView.data);
            }
        }
        ClosePopup();
    }

    function generateEventList(aEnrollee, aGroupId) {
        "use strict";
        var lKey,
            lEvents = getDataItems('Events'),
            lMetaEvents = getDataItems('MetaEvents'),
            lResult = [],
            lEvent = null,
            lReportEvent = null,
            lMetaEventsCurrentlyUnavailable = [16, 17],
            lMetaEventsCurrentlyAvailable = [],
            lPredicateBuilder = new SumoPredicateBuilder();

        lPredicateBuilder.AddNewExpressionConditional('EnrolleeId', aEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPredicateBuilder.AddNewExpressionConditional('IsConfirmed', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        if (aGroupId) {
            var lMetaEventList = getGroupMetaEvents([aGroupId]);
            lPredicateBuilder.AddNewExpressionConditional('MetaEventId', getMetaEventIds(lMetaEventList), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        } else {
            lPredicateBuilder.AddNewExpressionConditional('MetaEventId', lMetaEventsCurrentlyUnavailable, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        }
        lEvents = query(lEvents, lPredicateBuilder.RootExpression);

        for (lKey in lEvents) {
            if (lEvents.hasOwnProperty(lKey)) {
                lEvent = lEvents[lKey];
                lReportEvent = {};
                lReportEvent.id = lEvent.Id;
                lReportEvent.description = formatterMetaEvent(lEvent.MetaEventId);
                if (lEvent.IsOpen) {
                    lReportEvent.icon = dashboardSummaryReportIcon({ 'OrganizationId': aEnrollee.OrganizationId, 'Value': '2' });
                } else {
                    lReportEvent.icon = dashboardSummaryReportIcon({ 'OrganizationId': aEnrollee.OrganizationId, 'Value': '1' });
                }
                lReportEvent.openTime = formatEventStartDateTime(lEvent);
                lReportEvent.closeTime = formatEventEndDateTime(lEvent);
                lResult.push(lReportEvent);
            }
        }
        return lResult;
    }

    function dashboardReportColumnDelete_OnSuccess(aParams, aData) {
        var lData = getDataItems('DashboardReportColumn'),
            lItem,
            lKey;

        //for (lKey in lData) {
        //    if (lData.hasOwnProperty(lKey)) {
        //        lItem = lData[lKey];
        //        lData[lItem.Id] = null;
        //    }
        //}
    }

    function dashboardReportColumnDelete_OnFailure(aParams, a, b, c) {
        window.setTimeout(function () {
            WriteMultiple(aParams, dashboardReportColumnDelete_OnSuccess, dashboardReportColumnDelete_OnFailure, aParams, false);
        }, 5000);
    }

    function dashboardReportUpdate_OnSuccess(aParams, aData) {
        "use strict";
        var lReport = null,
            lData = getDataItems('DashboardReportColumn'),
            lBuilder = new SumoPredicateBuilder(),
            lDataWrite = [],
            lItem,
            lKey;

        if (aData.IsActive) {
            lReport = aData;
        } else {
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('DashboardReportId', aParams.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lData = query(lData, lBuilder.RootExpression);
            for (lKey in lData) {
                if (lData.hasOwnProperty(lKey)) {
                    lItem = lData[lKey];
                    lItem.IsActive = false;
                    lDataWrite.push(lItem);
                }
            }
            WriteMultiple(lDataWrite, dashboardReportColumnDelete_OnSuccess, dashboardReportColumnDelete_OnFailure, lDataWrite, false);
        }
        mActivityNotification.addNotification(localizeWrapper('cEnrolleeUpdatedCustomReport') + aData.Description);
        setDataItem(aData.Id, 'DashboardReport', lReport);
        createDashboardReportSelect();
        $('#uEnrolleeEventSummaryCustomReportSelect').val(aData.Id)
                                                     .trigger('change');
        ClosePopup();
    }


    function dashboardReportUpdateSort_OnSuccess(aParams, aData) {
        "use strict";
        var lData = mControls.SortReportListView.getDataSource(),
            lReport = gDashboardPage.getReportData(),
            lKey;

        for (lKey in lData) {
            if (lData.hasOwnProperty(lKey)) {
                delete lData[lKey].Description;
            }
        }
        mControls.SortReportListView.dispose();
        mControls.SortReportListView = null;
        WriteMultiple(lData, null, saveColumnList_OnWriteFailure, aData);

        mActivityNotification.addNotification(localizeWrapper('cEnrolleeReportSortOrderUpdate') + aData.Description);
        setDataItem(aData.Id, 'DashboardReport', aData);
        createDashboardReportSelect();
        $('#uEnrolleeEventSummaryCustomReportSelect').val(aData.Id)
                                                        .trigger('change')

        ClosePopup();
    }

    function uDashboardEditColumnFavoritesSaveButton_OnClick() {
        "use strict";
        var lSelect,
            lReport;

        if (mControls.ReportColumnUpdateValidator.IsValid()) {
            lSelect = $('#uEnrolleeEventSummaryCustomReportSelect').val();
            lReport = getDataItem(lSelect, 'DashboardReport');
            lReport.Description = veritracks.system.encodeHtml($('#uDashboardEditColumnName').val());

            if (mControls.SortReportListView.IsSorted()) {
                WriteSingle(lReport, dashboardReportUpdateSort_OnSuccess, null, null, true);
            }
            else {
                WriteSingle(lReport, dashboardReportUpdate_OnSuccess, null, lReport, true);
            }
            //dashboardReportUpdate_OnSuccess(null, lReport);
        }
    }

    function uDashboardEditColumnFavoritesDeleteButton_OnClick() {
        "use strict";
        var lSelect,
            lReport;

        lSelect = $('#uEnrolleeEventSummaryCustomReportSelect').val();
        lReport = getDataItem(lSelect, 'DashboardReport');
        lReport.IsActive = false;

        WriteSingle(lReport, dashboardReportUpdate_OnSuccess, null, lReport, true);
        //dashboardReportUpdate_OnSuccess(null, lReport);
        ClosePopup();

    }

    function uDashboardEditColumnFavorites_OnClick() {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar(),
            lBuilder = new SumoPredicateBuilder(),
            lHtml = [],
            lSelect,
            lReport,
            lDashboardReportData = [],
            lDashboardReportDescriptions = [],
            lKey,
            lDashboardId = [],
            lData = [];

        GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove', uDashboardEditColumnFavoritesDeleteButton_OnClick).appendTo(lButtonBar);
        GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', uDashboardEditColumnFavoritesSaveButton_OnClick).appendTo(lButtonBar);
        lHtml.push('<table id="uDashboardEditColumnTable">');
        lHtml.push('<tr>');
        lHtml.push('<td class="FormTitle">' + localizeWrapper('cEnrolleeName') + '</td>');
        lHtml.push('<td class="FormField">');
        lHtml.push('<input type="text" id="uDashboardEditColumnName" class="Validate ValidateRequired" />');
        lHtml.push('</td>');
        lHtml.push('</tr>');
        lHtml.push('</table>');
        lHtml.push('<div id="uEditSortReportListViewHolder" style="height: 280px;"></div>');
        DisplayPopup(localizeWrapper('cDashboardEditColFav'), lHtml.join(''), lButtonBar, false);

        lSelect = $('#uEnrolleeEventSummaryCustomReportSelect').val();
        lReport = getDataItem(lSelect, 'DashboardReport');

        $('#uDashboardEditColumnName').val(veritracks.system.decodeHtml(lReport.Description));
        mControls.ReportColumnUpdateValidator = new Validator('uDashboardEditColumnTable', mRegexValidation);


        lBuilder.AddNewExpressionConditional('DashboardReportId', lSelect, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var ltest = getDataItems('DashboardReportColumn');
        lDashboardReportData = query(getDataItems('DashboardReportColumn'), lBuilder.RootExpression);

        for (lKey in lDashboardReportData) {
            if (lDashboardReportData.hasOwnProperty(lKey)) {
                lDashboardId.push(lDashboardReportData[lKey].EnrolleeReportColumnId);
            }
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', lDashboardId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lDashboardReportDescriptions = query(getDataItems('EnrolleeReportColumn'), lBuilder.RootExpression);

        for (lKey in lDashboardReportData) {
            if (lDashboardReportData.hasOwnProperty(lKey)) {
                lDashboardReportData[lKey].Description = lDashboardReportDescriptions[lDashboardReportData[lKey].EnrolleeReportColumnId].Description;
            }
        }
        if (!isNullOrUndefined(mControls.SortReportListView)) {
            mControls.SortReportListView.dispose();
            mControls.SortReportListView = null;
        }
        mControls.SortReportListView = new sumo.controls.ListView('uEditSortReportListView', 'uEditSortReportListViewHolder', { 'keyField': 'SortOrder', 'selectMethod': 'single', 'cssClass': 'VeritracksSelectListView', 'canUnselect': false, 'showHeader': true }, [
            { 'id': 'SortIcon', 'title':localizeWrapper('cDashboardUpDown'), 'dataField': 'SortOrder', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': SortOrderFormatter },
                { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': ReportColumnFormatter },
        { 'id': 'SortOrder', 'title': localizeWrapper('cDashboardSortOrder'), 'dataField': 'SortOrder', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
        ]);


        for (lKey in lDashboardReportData) {
            if (lDashboardReportData.hasOwnProperty(lKey)) {
                lData[lDashboardReportData[lKey].SortOrder] = lDashboardReportData[lKey]
            }
        }
        mControls.SortReportListView.setDataSource(lData);
        mControls.SortReportListView.bind('selectedchanged', uChangeSortOrder_OnChange);
        gDashboardPage.ReportData(lReport);
    }

    function uDashboardViewEnrolleeButton_OnClick() {
        "use strict";
        var lItem = mControls.ListView.selectedDataItem();
        window.location.hash = "Enrollees.Offenders.Profile.Events." + lItem.EnrolleeId;
    }

    function uEventListViewPaginator_OnPageChanged(aSender, aParams, aData) {
        if (!isNullOrUndefined(mData.EventData)) {
            mData.EventDataPaginated = aSender.paginate(mData.EventData);
            mControls.EventsListView.setDataSource(mData.EventDataPaginated);
        }
    }

    function uEventNoteText_OnChange() {
        "use strict";
        var lEventNoteTextValue = $('#uEventNoteText').val();
        if ($.trim(lEventNoteTextValue) !== '' && mControls.EventsListView.selected() !== null && mControls.EventsListView.selected().length > 0) {
            $('.EventsAddNoteButton').removeClass('Disabled');
        } else {
            $('.EventsAddNoteButton').addClass('Disabled');
        }
    }

    function showConfirmEventsDefaultDialog() {
        "use strict";
        showConfirmEventsDialog();
    }

    function showConfirmEventsDialog(aGroupId) {
        "use strict";
        var lButtonBar = GenerateButtonCommandBar(),
            lEnrollee = getDataItem(mControls.ListView.selected(), 'Enrollees'),
            lEvents = generateEventList(lEnrollee, aGroupId),
            lTitle = localizeWrapper('cEventConfirmEventsFor'),
            lHtml = [],
            lColumns = [];

        if (aGroupId) {
            var lGroup = getDataItem(aGroupId, 'EventGroup');
            if (lGroup)
                lTitle = dataItemFormatter('EventGroup', 'Description', 'UNKNOWN', lGroup.Id) + ' - ' + localizeWrapper('cEventConfirmFor');
        }

        lColumns.push({ 'id': 'Selected', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': 'SelectionColumn', 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': true });
        lColumns.push({ 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'description', 'width': 'autoData', 'cssClass': 'NoWrap', 'dataType': 'string' });
        lColumns.push({ 'id': 'Icon', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'icon', 'width': 'autoHeader', 'cssClass': 'CenterImage', 'dataType': 'string' });
        lColumns.push({ 'id': 'StartTime', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'openTime', 'width': 'autoData', 'cssClass': 'NoWrap', 'dataType': 'date' });
        lColumns.push({ 'id': 'StopTime', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'closeTime', 'width': 'autoData', 'cssClass': 'NoWrap', 'dataType': 'date' });

        lHtml.push('<div class="" style="background-color: white">');
        lHtml.push(' <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 1px;">');
        lHtml.push(' <tr class="pEventsNotesWrite">');
        lHtml.push(' <td>'+localizeWrapper('cEventNotes')+'</td>');
        lHtml.push(' <td>&nbsp;<input id="uEventNoteText" type="text" name="uEventNoteText" style="width:420px;"  /></td>');
        lHtml.push(' </tr>');
        lHtml.push(' </table>');
        lHtml.push('</div>');
        lHtml.push('<div class="ListViewHolder" id="uEventListViewPaginatorHolder"></div>');
        lHtml.push('<div style="height: 200px;" id="uEventListHolder"></div>');
        GenerateButton(localizeWrapper('cEnrolleeAddNote'), 'pEventsNotesWrite EventsAddNoteButton ', addNote_ButtonClick).appendTo(lButtonBar);
        GenerateButton(localizeWrapper('cEventConfirm'), 'pEventsWrite ConfirmEvent', 'gDashboardPage.confirmEventsDialog_OkButtonClick()').appendTo(lButtonBar);
        DisplayPopup(lTitle + lEnrollee.FullName, lHtml.join(''), lButtonBar, false);
        applyUserPermissions([1, 32]);
        $('#uEventNoteText').change(uEventNoteText_OnChange).keyup(uEventNoteText_OnChange).keypress(uEventNoteText_OnChange).change();
        mControls.EventsListView = new sumo.controls.ListView('uEventListview', 'uEventListHolder',
            {
                'keyField': 'id',
                'keyFieldType': 'number',
                'cssClass': 'VeritracksListView',
                'selectMethod': 'auto',
                'canUnselect': true
            },
            lColumns);
        mControls.EventsListViewPaginator = new sumo.controls.Paginator('uEventListViewPaginator', 'uEventListViewPaginatorHolder', {
            'ItemCount': count(lEvents),
            'ItemsPerPage': gPaginationSettings.DashboardEventsItems
        });
        mControls.EventsListViewPaginator.bind('pagechanged', uEventListViewPaginator_OnPageChanged);
        mControls.EventsListView.bind('selectedchanged', uEventNoteText_OnChange);

        mData.EventData = lEvents;
        mControls.EventsListViewPaginator.setPage(1);
        mControls.EventsListView.data = lEnrollee;
    }

    function showViewSchedulePopup() {
        "use strict";
        var lEnrolleeId = mControls.ListView.selected();

        ReloadEnrolleeSchedules(lEnrolleeId, function (a, b) {
            enrolleeSchedulePopup_Init(lEnrolleeId);
        })
    }

    function showEnhancedSchedulePopup() {
      var lEnrolleeId = mControls.ListView.selected();

      mEnrolleesData.OffenderCurrentId = lEnrolleeId;

      function enrolleesScheduleAddressesOnSuccess(aParams, aData) {
          "use strict";
          EnrolleeProfileSchedules_OnLoad(aParams);
          mEnrolleesData.SchedulesTargetsClean = $.extend({}, mEnrolleesData.SchedulesZonesClean);
          enrolleesScheduleAddressesDataListConverter(aParams.EnrolleeId, aData);
          mEnrolleesData.CarveOutTargetsClean = [];// = $.extend({}, mEnrolleesData.SchedulesZonesClean);


          uCarveOutScheduleButton_OnClick()
      }

      function EnrolleeProfileSchedules_Init() {
          "use strict";
          var lBuilder = new SumoPredicateBuilder()
          lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
          ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesScheduleAddressesOnSuccess, Sad, { 'EnrolleeId': mEnrolleesData.OffenderCurrentId, 'TargetZoneId': null, 'TargetEnrolleeId': null }, null, 20);
      }

       EnrolleeProfileSchedules_Init()

    }


    function renderComplete() {
        "use strict";
        //uDashboardContentCell = $('#uDashboardContentCell');
        mData.ListViewPanel = $('#mData.ListViewPanel');

        $('#uConfirmEventsButton').click(showConfirmEventsDefaultDialog);
        $('#uViewScheduleButton').click(showViewSchedulePopup);
        $('#uEnhancedScheduleButton').click(showEnhancedSchedulePopup);

        // $('#uDashboardViewEnrolleeButton').click(uDashboardViewEnrolleeButton_OnClick);
        $('#uDashboardEditColumnFavorites').click(uDashboardEditColumnFavorites_OnClick);
        $('#uColumnEditButton').click(toggleColumnSelection);
        $('#uColumnDefinitionSave').click(saveColumnSelection);
        $('#uColumnDefinitionCancel').click(toggleColumnSelection);
        $('#uSortReport').click(SortReport_OnClick);
        $(window).resize();

        //resetContentHolders();

        //resetContentHoldersDashboard();
        mThis.trigger('render');
    }

    this.selectFromDashboardListView = function(aEnrolleeId) {
        "use strict";
        if (!isNullOrUndefined(mControls.ListView)) {
            mControls.ListView.selected(aEnrolleeId);
        }
    }

    this.dispose = function () {
        var i,
            lTile,
            lEvent;

        for (i = 0; i < mData.EventList.length; i++) {
            lEvent = mData.EventList[i];
            mCache.unbind(lEvent.name, lEvent.handler);
        }
        mData.EventList = null;

        for (i = 0; i < mData.CacheList.length; i++) {
            lEvent = mData.CacheList[i];
            mCache.RemoveUpdatableItem(lEvent);
        }

        if (!isNullOrUndefined(mControls.ListView)) {
            mControls.ListView.unbind('selectedchanged', mEnrolleeEventSummaryListView_OnSelectedChanged);
            mCache.unbind('EnrolleeReportupdated', dataItem_OnUpdate);
            mCache.unbind('FullEnrolleeReportupdated', dataItem_OnUpdate);
            mCache.unbind('DeviceLastContactupdated', DeviceLastContact_Updated);
            mControls.ListViewFilter.unbind('filter', uEnrolleeEventSummaryFilter_OnFilter);
            mControls.ColumnsDropdown.unbind('opened', showColumnSelect);
            mControls.ColumnsDropdown.unbind('closed', hideColumnSelect);
            mControls.ColumnsDropdown.dispose();
            mControls.ColumnsDropdown = null;
            for (i in mControls.Tiles) {
                if (mControls.Tiles.hasOwnProperty(i)) {
                    mControls.Tiles[i].dispose();
                    mControls.Tiles[i] = null;
                }
            }
            mControls.Tiles = null;

            $('#uConfirmEventsButton').unbind('click', showConfirmEventsDefaultDialog);
            $('#uViewScheduleButton').unbind('click', showViewSchedulePopup);
            //$('#uDashboardViewEnrolleeButton').unbind('click', uDashboardViewEnrolleeButton_OnClick);
            $('#uDashboardEditColumnFavorites').unbind('click', uDashboardEditColumnFavorites_OnClick);
            $('#uColumnEditButton').unbind('click', toggleColumnSelection);
            $('#uColumnDefinitionSave').unbind('click', saveColumnSelection);
            $('#uColumnDefinitionCancel').unbind('click', toggleColumnSelection);

            mControls.ListView.dispose();
            mControls.ListView = null;
            mControls.ListViewFilter.dispose();
            mControls.ListViewFilter = null;
            mControls.ListViewPaginator.dispose();
            mControls.ListViewPaginator = null;
            mControls.ColumnsListView.dispose();
            mControls.ColumnsListView = null;

            if (!isNullOrUndefined(mControls.EventsListViewPaginator)) {
                mControls.EventsListViewPaginator.unbind('pagechanged', uEventListViewPaginator_OnPageChanged);
                mControls.EventsListViewPaginator.dispose();
                mControls.EventsListViewPaginator = null;
            }

            if (!isNullOrUndefined(mControls.EventsListView)) {
                mControls.EventsListView.unbind('selectedchanged', uEventNoteText_OnChange);
                mControls.EventsListView.dispose();
                mControls.EventsListView = null;
            }
            mControls.NotesManager = null;

            mControls = null;
            mData = null;
            DashboardPage.prototype.dispose.call(this);
        }
    };

    this.identifyDeviceActionType = function (aDeviceType) {
        var lItem = mControls.ListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lDevices = getDataItems('Devices'),
        productDetails = lItem[2021].split("/"),
        serialNumber = productDetails[0];

        lBuilder.AddNewExpressionConditional('SerialNumber', serialNumber, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDevices = query(lDevices, lBuilder.RootExpression);

        if (lDevices.length > 0){
            displayDeviceActionPopup(aDeviceType, lDevices.length - 1, lItem.FullName);
        }
    };

    this.identifyEnrolleeOnDemandAction = function () {
        var lItem = mControls.ListView.selectedDataItem();

        createSoberTrackOnDemand(1, lItem.EnrolleeId, lItem.OrganizationId);
    }

    this.render();
}
DashboardPage.prototype = new sumo.Class();
DashboardPage.prototype.constructor = DashboardPage;
DashboardPage.prototype.baseClass = sumo.Class;

function setScroll() {
    var container = $('#uEnrolleeEventSummaryListViewViewPort'),
        scrollTo = $('.sumo-data-row-selected');

    if (scrollTo.length > 0 && container.length > 0) {
        if (scrollTo.offset().top < container.offset().top) {
            container.scrollTop(container.scrollTop() - (container.offset().top - scrollTo.offset().top));

        } else if (scrollTo.offset().top > container[0].scrollHeight || scrollTo.offset().top > (container[0].clientHeight + container[0].offsetTop)) {
            container.scrollTop(container.scrollTop() + 17);
        } else {

        }

    }//end of if
}

function uMasterContentHolder_OnLoad() {
    "use strict";

    $('#uMasterMenuPanel').hide();

    gDashboardPage = new DashboardPage();
    gDashboardPage.bind('render', systemCacheItems_Init, null);    
    resetContentHolders();
    applyUserPermissions([1, 2, 4, 7, 12,20, 22, 31, 36]);
}

function resetContentHoldersDashboard(aMasterHeight, aMasterWidth) {
    "use strict";
    if (!isNullOrUndefined(gDashboardPage)) {// && !isNullOrUndefined(gDashboardPage.getEnrolleeEventSummaryListViewPanel())) {
        var lContentWidth = (aMasterWidth - 20);
        setWidth('#uEnrolleeEventSummaryListViewPanel', lContentWidth);
        gDashboardPage.resize();
    }
    // localize here
    veritracks.localization.localizeTitle();
}

function displayUserAgreement() {
    "use strict";
    var lAgreementFlag = veritracks.system.clientSetting('UserAgreementEnable'),
        lButtonBar = GenerateButtonCommandBar();

    var queryString = window.location.search;   
    var urlParams = new URLSearchParams(queryString);
    var returnUrl = urlParams.get('uReturnPath');   
    
    if ((!isNullOrUndefined(returnUrl) && returnUrl != '') || gUserDetails.AccountStatus == 'EXPIRED' || gUserDetails.AccountStatus == 'RESETPOLICY' || gUserDetails.AccountStatus == 'RESET') {             
        return;
    }
    
    function AgreementOnSuccess(responseText, textStatus, XMLHttpRequest) {
        lButtonBar.append(GenerateButton(localizeWrapper('cUserAgreementAccept'), 'Accept', ' userAgreementAccepted()'));
        lButtonBar.append(GenerateButton(localizeWrapper('cUserAgreementDecline'), 'Decline', 'userAgreementDeclined()'));
        DisplayPopup("<div id='uUserAgreementContainer' style='display:inline-block;'>User Agreement</div>", responseText, lButtonBar, true, false, 'userAgreementDeclined');
        checkSessionManagement();

    }

    if (lAgreementFlag) {
        if (!isNullOrUndefined(sessionStorage.UserAgreement) && sessionStorage.UserAgreement == "false") {
            sessionStorage.UserAgreement = true;
            $.get('Interface/User.Agreement.Layout.htm', AgreementOnSuccess);
        } else if (isNullOrUndefined(sessionStorage.UserAgreement)){
            sessionStorage.UserAgreement = true;
            $.get('Interface/User.Agreement.Layout.htm', AgreementOnSuccess);
        }

    } else {
        checkSessionManagement();
    }
}

function userAgreementAccepted() {
    "use strict";
    sessionStorage.UserAgreement = true;
    ClosePopup();

    function uUserAgreement_OnSuccess(aParams, aData) {
        //
    }

    LogUserAgreement(gUserDetails.UserId, true, uUserAgreement_OnSuccess, Sad);
}

function userAgreementDeclined() {
    "use strict";
    gUserDetails.UserAgreement = false;
    ClosePopup();

    function uUserAgreement_OnSuccess(aParams, aData) {
        veritracks.system.logout();
    }

    LogUserAgreement(gUserDetails.UserId, false, uUserAgreement_OnSuccess, Sad);

}

function onSessionSuccess(aParams, aMultiSession) {
    "use strict";
    var lOneSessionSetting = veritracks.system.clientSetting('OneSessionEnable'),
        lButtonBar;

    if (lOneSessionSetting == 1 && aMultiSession == true) {
        //close any popups open
        ClosePopup();
        lButtonBar = GenerateButtonCommandBar();
        lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'veritracks.system.logout()'));
        DisplayPopup("<div id='uUserSessionNotAllowedContainer' style='display:inline-block;'>Session Not Allowed</div>", '<div style="width:100%;height:100%">Your user is not allowed multiple vertiracks sessions. You will be redirected to login page. Please close all other windows before attempting to login again.</div>', lButtonBar, true, false, 'veritracks.system.logout');
    }

}

function checkSessionManagement() {
    "use strict";
    var lOneSessionSetting = veritracks.system.clientSetting('OneSessionEnable');
    if (lOneSessionSetting == 1) {
        CheckSessions(gUserDetails.UserId, veritracks.security.controller.tryGetSecurityToken(), onSessionSuccess, Sad);
    }

}

function GetEnrolleeTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEnrolleeTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

function GetEventTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEventTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};


function GetZoneTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetZoneTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};



function GetAnalysisTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetAnalysisTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};



function GetInventoryTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetInventoryTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};



function GetReportTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetReportTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

function GetAgentTiles(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    var User
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetAgentTile', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': gUserDetails.UserId,
            'aOri': gUserDetails.OrganizationIds.join(',')
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};




